import React, {PureComponent} from 'react';
import {Link} from "react-router-dom";
import {Classes, Overlay} from "@blueprintjs/core";
import {getCurrentUserId, getJwt} from '../../services/authService';
import http from "../../services/httpService";
import toastr from "toastr";

export default class UpsellModal extends PureComponent {
    state = {
        overlayIsOpen: false,
        title: '',
        content: '',
        buttonLabel: '',
        buttonLink: '',
        plan: '',
        planPeriod: true,
        spinnerActiveId: '',
        stripePlans: [],
        selectedPlan: '',
        selectedSourceId: this.props.selectedSource,
        selectedProject: '',
        chosenPlan: 'boost_yearly',
        chosenPlanFull: '',
        subscribedAt: '',
        clicked: false,
        showUpgradeModal: false,
        remainingMonths: '',
        projects: this.props.user ? this.props.user.sources.data : '',
        user: this.props.user ? this.props.user : '',
        remainingPrice: '',
        remainingPricePerMonth: '',
        allPlansData: '',
        selectedPlanFull: ''
    }

    handleSubscriptionCompleted = (stripePlanId) => {
        if (stripePlanId === 'essentials_monthly') {
            this.props.history.push('/essentials-monthly-confirmation')
        } else if (stripePlanId === 'boost_monthly') {
            this.props.history.push('/boost-monthly-confirmation')
        } else if (stripePlanId === 'essentials_yearly') {
            this.props.history.push('/essentials-yearly-confirmation')
        } else if (stripePlanId === 'boost_yearly') {
            this.props.history.push('/boost-yearly-confirmation')
        } else {
            this.props.history.push('/subscription-confirmation')
        }
    }

    handleFreePlan = async (stripePlanId) => {
        /* Button should be disabled when spinner is active */
        this.setState({spinnerActiveId: stripePlanId})
        let user = await this.props.user;
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let project = await user.sources.data.find(project => projectId.toString() === project.id.toString())
        let smsPlatform = project ? project.platforms.find(plan => plan.platform === 'sms') : '';
        let plan = smsPlatform ? smsPlatform.plan : '';

        if (user && user.customer && project && (project.platforms.length < 1 || !project.platforms || !plan)) {
            //console.log('Usao 1')
            let userId = user.id || getCurrentUserId();
            // try{
            //     const stripeResult = await http.post('api/user/' + userId + '/project/' + projectId + '/customers/create_customer')
            // }catch{
            //     this.setState({spinnerActiveId: ''})
            //     toastr.error("Stripe customer couldn't be created, please try again.");
            // }
            try {
                //console.log('free plan call:', 'api/user/' + userId + '/project/' + projectId + '/customers/subscribe_to_plan')
                const result = await http.post('api/user/' + userId + '/project/' + projectId + '/customers/subscribe_to_plan', {"plan": stripePlanId}, {headers: {authorization: getJwt()}})
                // console.log('Evo rezultata za free plan: ', result)
                this.setState({spinnerActiveId: ''})
                // toastr.success("You have successfully subscribed to Free Plan.")
                // this.props.history.push('/distribution-platforms');
                // this.props.history.push('/channels')
                this.props.history.push('/free-confirmation')
                localStorage.removeItem('selectedTeam');
                localStorage.removeItem('navigateBackTo');
            } catch (ex) {
                this.setState({spinnerActiveId: ''})
                toastr.error("Free plan was not activated, please try again.");
            }

        } else if (user && !user.customer && project && (project.platforms.length < 1 || !project.platforms || !plan)) {
            let userId = user.id || getCurrentUserId();
            //console.log('Usao 2')
            try {
                const stripeResult = await http.post('api/user/' + userId + '/project/' + projectId + '/customers/create_customer', {}, {headers: {authorization: getJwt()}})
                // console.log('Evo rezultata za create stripe customer: ', stripeResult)
                try {
                    const freePlanResult = await http.post('api/user/' + userId + '/project/' + projectId + '/customers/subscribe_to_plan', {"plan": stripePlanId}, {headers: {authorization: getJwt()}})
                    // console.log('Evo rezultata za free plan: ', freePlanResult)
                    this.setState({spinnerActiveId: ''})
                    // toastr.success("You have successfully subscribed to Free Plan.")
                    // this.props.history.push('/channels')
                    this.props.history.push('/free-confirmation')
                    localStorage.removeItem('selectedTeam');
                    localStorage.removeItem('navigateBackTo');
                } catch (ex) {
                    this.setState({spinnerActiveId: ''})
                    toastr.error("Free plan was not activated, please try again.");
                }
            } catch (ex) {
                this.setState({spinnerActiveId: ''})
                toastr.error("Stripe customer was not created, please try again.");
            }
        }
        // const result = await http.get('api/user/' + getCurrentUserId() + '/teams', {headers: {authorization: getJwt()}});
        // let userTeams = result.data.teams.data;
        // let userTeamsIn = result.data.teams_in.data;
    }

    handlePremiumPlan = async (amount, stripePlanId, freeTrial = false, discountedAmount) => {
        //console.log('amount and planId: ', amount + ' ' + stripePlanId)
        this.setState({spinnerActiveId: stripePlanId})
        let user = await this.props.user;
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let project = await user.sources.data.find(project => projectId.toString() === project.id.toString())
        let smsPlatform = project ? project.platforms.find(plan => plan.platform === 'sms') : '';
        let plan = smsPlatform ? smsPlatform.plan : '';

        if (user && user.customer && project) {
            /*GET PAYMENT METHODS PROJECT*/
            try {
                const result = await http.get('/api/user/' + user.id + '/project/' + projectId + '/customers/get_payment_methods_project', {headers: {authorization: getJwt()}});
                let projectPaymentMethods = result.data.project_payment_methods;
                let userPaymentMethods = result.data.user_payment_methods;
                // console.log('payment methods: ', projectPaymentMethods, userPaymentMethods)
                if (
                    (userPaymentMethods && userPaymentMethods.length && userPaymentMethods[0].payment_method_id) ||
                    (projectPaymentMethods && projectPaymentMethods.length && projectPaymentMethods[0].payment_method_id)
                ) {
                    this.props.history.push('/existing-payment', {
                        amount,
                        stripePlanId,
                        freeTrial,
                        discountedAmount
                    })
                } else {
                    this.props.history.push('/add-funds/billing-details', {
                        amount,
                        stripePlanId,
                        freeTrial,
                        discountedAmount
                    })
                }
                // console.log('projectPaymentMethods: ', projectPaymentMethods);
                // console.log('userPaymentMethods: ', userPaymentMethods);
                this.setState({spinnerActiveId: ''})
            } catch (ex) {
                toastr.error("Couldn't receive payment methods, please try again.");
                this.setState({spinnerActiveId: ''})
            }


            // try{
            //     const result = await http.post('api/user/' + user.id + '/project/' + projectId + '/project_subscriptions/subscribe_to_plan')
            //     console.log('Evo rezultata za free plan: ', result)
            //     // this.props.history.push('/distribution-platforms');
            // } catch(ex){
            //     toastr.error("Free plan was not activated, please try again.");
            // }
        } else if (user && !user.customer && project) {
            let userId = user.id || getCurrentUserId();
            try {
                const stripeResult = await http.post('api/user/' + userId + '/project/' + projectId + '/customers/create_customer', {}, {headers: {authorization: getJwt()}})
                // console.log('create stripe customer results: ', stripeResult)
                this.props.history.push('/add-funds/billing-details', {amount, stripePlanId})
            } catch (ex) {
                toastr.error("Stripe customer was not created, please try again.");
                this.setState({spinnerActiveId: ''})
            }
        }
        // const result = await http.get('api/user/' + getCurrentUserId() + '/teams', {headers: {authorization: getJwt()}});
        // let userTeams = result.data.teams.data;
        // let userTeamsIn = result.data.teams_in.data;
    }


    planPeriodToggle = async () => {
        if (this.state.planPeriod === true) {
            await this.setState({planPeriod: false});
        } else {
            await this.setState({planPeriod: true});

        }


    }

    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }


    calculateRemainingPrice = async (resultStripePlans) => {
        //console.log('entered calculateRemainingPrice');

        let selectedProject = this.state.projects.find(project => {
            return project.id === parseInt(this.state.selectedSourceId)
        })

        let subscribedAt = ''
        let monthsPayed = ''
        let dateObj = new Date();

        let month = dateObj.getUTCMonth() + 1; //months from 1-12
        let day = dateObj.getUTCDate();
        let year = dateObj.getUTCFullYear();

        let todayDate = year + "-" + month + "-" + day;
        //console.log('todayDate: ', todayDate)
        //console.log('mount - selectedProject: ', selectedProject);
        if (selectedProject && selectedProject !== '') {
            //formatting date from database and todays date for
            //console.log('selectedProject is not empty')
            if (selectedProject.platforms[3].subscribed_at !== null) {
                subscribedAt = (selectedProject.platforms[3].subscribed_at).substring(0, 10)
                //console.log('subscribedAt: ', subscribedAt)

                let year1 = todayDate.substring(0, 4)
                let month1 = todayDate.substring(5, 7) - 1
                let day1 = todayDate.substring(8, 9)
                //console.log('date1: ', year1 + '-' + month1 + '-' + day1)
                let year2 = subscribedAt.substring(0, 4)
                let month2 = subscribedAt.substring(5, 7) - 1
                let day2 = subscribedAt.substring(9, 10)
                //console.log('date2: ', year2 + '-' + month2 + '-' + day2)

                //creating date formats available for calculating month difference
                let date1 = new Date(year1, month1, day1)
                let date2 = new Date(year2, month2, day2)

                //calculating remaining months
                monthsPayed = await this.monthDiff(date1, date2)

                //console.log('months payed: ', monthsPayed)
                let remainingMonths = 12 - monthsPayed

                //console.log('remaining months: ', remainingMonths)
                //calculating remaining price for essentials yearly -> boost yearly
                if (resultStripePlans && resultStripePlans !== '') {
                    //console.log('stripePlans are not empty')
                    let boostYearlyPrice = resultStripePlans[4].amount / 100;
                    //console.log('boostYearlyPrice: ', '$' + boostYearlyPrice)
                    let alreadyPayed = resultStripePlans[3].amount / 100;
                    //console.log('alreadyPayed: ', '$' + alreadyPayed)
                    let remainingEssentialToPay = monthsPayed * resultStripePlans[3].amount / 100;
                    //console.log('remainingEssentialToPay: ', '$' + remainingEssentialToPay)

                    let remainingPrice = boostYearlyPrice - (alreadyPayed - remainingEssentialToPay);
                    let remainingPricePerMonth = remainingPrice / 12
                    await this.setState({
                        selectedProject,
                        subscribedAt,
                        remainingMonths,
                        remainingPrice,
                        remainingPricePerMonth
                    })
                }
            }
        }
    }
    openUpgradeModal = () => {
        this.setState({
            showUpgradeModal: true
        })
    }
    closeUpgradeModal = () => {
        this.setState({
            showUpgradeModal: false
        })
    }

    togglePlanPeriod = async () => {
        let planPeriod = await !this.state.planPeriod
        await this.setState({
            planPeriod
        })
        let chosenPlan = this.state.chosenPlan
        //console.log('chosen plan: ', chosenPlan);
        if (chosenPlan.includes('yearly')) {
            chosenPlan = chosenPlan.substring(0, chosenPlan.length - 7)
        } else {
            chosenPlan = chosenPlan + '_yearly'
        }
        this.choosePlan(chosenPlan)
    }


    choosePlan = async (chosenPlan) => {
        //console.log('chosenPlan: ', chosenPlan)
        let chosenPlanFull = this.state.stripePlans.filter(
            stripePlan => {
                return stripePlan.plan_id === chosenPlan
            }
        )
        await this.setState({
            chosenPlan,
            chosenPlanFull: chosenPlanFull[0]
        })
    }


    getSelectedPlan = async () => {
        let user = await this.props.user;
        let projectId = await this.props.selectedSource ? this.props.selectedSource : localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        let project = await user.sources.data.find(project => projectId.toString() === project.id.toString());
        if (project && project.platforms.length < 1) {
            await this.props.updateUserFromServer()
        }
        if (project && project.platforms.length > 0) {
            //console.log('project: ', project)
            let smsPlatform = await project.platforms.find(platform => platform.platform === 'sms');
            let selectedPlan = await smsPlatform ? smsPlatform.plan : '';
            if (selectedPlan && !this.state.selectedPlan) {
                await this.setState({selectedPlan})
            }
        }
    }
    hoverIf = () => {
        if (this.state.clicked === false) {
            // console.log('this.state.clicked is false')
            let visiblePlansCount = document.getElementsByClassName('plan').length


            if (visiblePlansCount === 4) {
                //hover elements
                let col1row1 = document.querySelector(' #features .feature:nth-of-type(1)')
                let col2row1 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(1)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(1)')
                let col3row1 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(1)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(1)')
                let col4row1 = document.querySelector(' #free_plan .feature:nth-of-type(1)')


                col1row1.addEventListener('mouseover', () => this.hover(1), false)
                col1row1.addEventListener('mouseout', () => this.hoverOut(1), false)
                col2row1.addEventListener('mouseover', () => this.hover(1), false)
                col2row1.addEventListener('mouseout', () => this.hoverOut(1), false)
                col3row1.addEventListener('mouseover', () => this.hover(1), false)
                col3row1.addEventListener('mouseout', () => this.hoverOut(1), false)
                col4row1.addEventListener('mouseover', () => this.hover(1), false)
                col4row1.addEventListener('mouseout', () => this.hoverOut(1), false)

                let col1row2 = document.querySelector(' #features .feature:nth-of-type(2)')
                let col2row2 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(2)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(2)')
                let col3row2 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(2)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(2)')
                let col4row2 = document.querySelector(' #free_plan .feature:nth-of-type(2)')

                col1row2.addEventListener('mouseover', () => this.hover(2), false)
                col1row2.addEventListener('mouseout', () => this.hoverOut(2), false)
                col2row2.addEventListener('mouseover', () => this.hover(2), false)
                col2row2.addEventListener('mouseout', () => this.hoverOut(2), false)
                col3row2.addEventListener('mouseover', () => this.hover(2), false)
                col3row2.addEventListener('mouseout', () => this.hoverOut(2), false)
                col4row2.addEventListener('mouseover', () => this.hover(2), false)
                col4row2.addEventListener('mouseout', () => this.hoverOut(2), false)

                let col1row3 = document.querySelector(' #features .feature:nth-of-type(3)')
                let col2row3 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(3)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(3)')
                let col3row3 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(3)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(3)')
                let col4row3 = document.querySelector(' #free_plan .feature:nth-of-type(3)')

                col1row3.addEventListener('mouseover', () => this.hover(3), false)
                col1row3.addEventListener('mouseout', () => this.hoverOut(3), false)
                col2row3.addEventListener('mouseover', () => this.hover(3), false)
                col2row3.addEventListener('mouseout', () => this.hoverOut(3), false)
                col3row3.addEventListener('mouseover', () => this.hover(3), false)
                col3row3.addEventListener('mouseout', () => this.hoverOut(3), false)
                col4row3.addEventListener('mouseover', () => this.hover(3), false)
                col4row3.addEventListener('mouseout', () => this.hoverOut(3), false)

                let col1row4 = document.querySelector(' #features .feature:nth-of-type(4)')
                let col2row4 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(4)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(4)')
                let col3row4 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(4)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(4)')
                let col4row4 = document.querySelector(' #free_plan .feature:nth-of-type(4)')

                col1row4.addEventListener('mouseover', () => this.hover(4), false)
                col1row4.addEventListener('mouseout', () => this.hoverOut(4), false)
                col2row4.addEventListener('mouseover', () => this.hover(4), false)
                col2row4.addEventListener('mouseout', () => this.hoverOut(4), false)
                col3row4.addEventListener('mouseover', () => this.hover(4), false)
                col3row4.addEventListener('mouseout', () => this.hoverOut(4), false)
                col4row4.addEventListener('mouseover', () => this.hover(4), false)
                col4row4.addEventListener('mouseout', () => this.hoverOut(4), false)

                let col1row5 = document.querySelector(' #features .feature:nth-of-type(5)')
                let col2row5 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(5)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(5)')
                let col3row5 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(5)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(5)')
                let col4row5 = document.querySelector(' #free_plan .feature:nth-of-type(5)')

                col1row5.addEventListener('mouseover', () => this.hover(5), false)
                col1row5.addEventListener('mouseout', () => this.hoverOut(5), false)
                col2row5.addEventListener('mouseover', () => this.hover(5), false)
                col2row5.addEventListener('mouseout', () => this.hoverOut(5), false)
                col3row5.addEventListener('mouseover', () => this.hover(5), false)
                col3row5.addEventListener('mouseout', () => this.hoverOut(5), false)
                col4row5.addEventListener('mouseover', () => this.hover(5), false)
                col4row5.addEventListener('mouseout', () => this.hoverOut(5), false)

                let col1row6 = document.querySelector(' #features .feature:nth-of-type(6)')
                let col2row6 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(6)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(6)')
                let col3row6 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(6)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(6)')
                let col4row6 = document.querySelector(' #free_plan .feature:nth-of-type(6)')

                col1row6.addEventListener('mouseover', () => this.hover(6), false)
                col1row6.addEventListener('mouseout', () => this.hoverOut(6), false)
                col2row6.addEventListener('mouseover', () => this.hover(6), false)
                col2row6.addEventListener('mouseout', () => this.hoverOut(6), false)
                col3row6.addEventListener('mouseover', () => this.hover(6), false)
                col3row6.addEventListener('mouseout', () => this.hoverOut(6), false)
                col4row6.addEventListener('mouseover', () => this.hover(6), false)
                col4row6.addEventListener('mouseout', () => this.hoverOut(6), false)

                let col1row7 = document.querySelector(' #features .feature:nth-of-type(7)')
                let col2row7 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(7)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(7)')
                let col3row7 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(7)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(7)')
                let col4row7 = document.querySelector(' #free_plan .feature:nth-of-type(7)')

                col1row7.addEventListener('mouseover', () => this.hover(7), false)
                col1row7.addEventListener('mouseout', () => this.hoverOut(7), false)
                col2row7.addEventListener('mouseover', () => this.hover(7), false)
                col2row7.addEventListener('mouseout', () => this.hoverOut(7), false)
                col3row7.addEventListener('mouseover', () => this.hover(7), false)
                col3row7.addEventListener('mouseout', () => this.hoverOut(7), false)
                col4row7.addEventListener('mouseover', () => this.hover(7), false)
                col4row7.addEventListener('mouseout', () => this.hoverOut(7), false)

                let col1row8 = document.querySelector(' #features .feature:nth-of-type(8)')
                let col2row8 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(8)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(8)')
                let col3row8 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(8)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(8)')
                let col4row8 = document.querySelector(' #free_plan .feature:nth-of-type(8)')

                col1row8.addEventListener('mouseover', () => this.hover(8), false)
                col1row8.addEventListener('mouseout', () => this.hoverOut(8), false)
                col2row8.addEventListener('mouseover', () => this.hover(8), false)
                col2row8.addEventListener('mouseout', () => this.hoverOut(8), false)
                col3row8.addEventListener('mouseover', () => this.hover(8), false)
                col3row8.addEventListener('mouseout', () => this.hoverOut(8), false)
                col4row8.addEventListener('mouseover', () => this.hover(8), false)
                col4row8.addEventListener('mouseout', () => this.hoverOut(8), false)
                col4row8.addEventListener('mouseover', () => this.hover(8), false)
                col4row8.addEventListener('mouseout', () => this.hoverOut(8), false)

                let col1row9 = document.querySelector(' #features .feature:nth-of-type(9)')
                let col2row9 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(9)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(9)')
                let col3row9 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(9)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(9)')
                let col4row9 = document.querySelector(' #free_plan .feature:nth-of-type(9)')

                col1row9.addEventListener('mouseover', () => this.hover(9), false)
                col1row9.addEventListener('mouseout', () => this.hoverOut(9), false)
                col2row9.addEventListener('mouseover', () => this.hover(9), false)
                col2row9.addEventListener('mouseout', () => this.hoverOut(9), false)
                col3row9.addEventListener('mouseover', () => this.hover(9), false)
                col3row9.addEventListener('mouseout', () => this.hoverOut(9), false)
                col4row9.addEventListener('mouseover', () => this.hover(9), false)
                col4row9.addEventListener('mouseout', () => this.hoverOut(9), false)

                let col1row10 = document.querySelector(' #features .feature:nth-of-type(10)')
                let col2row10 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(10)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(10)')
                let col3row10 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(10)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(10)')
                let col4row10 = document.querySelector(' #free_plan .feature:nth-of-type(10)')

                col1row10.addEventListener('mouseover', () => this.hover(10), false)
                col1row10.addEventListener('mouseout', () => this.hoverOut(10), false)
                col2row10.addEventListener('mouseover', () => this.hover(10), false)
                col2row10.addEventListener('mouseout', () => this.hoverOut(10), false)
                col3row10.addEventListener('mouseover', () => this.hover(10), false)
                col3row10.addEventListener('mouseout', () => this.hoverOut(10), false)
                col4row10.addEventListener('mouseover', () => this.hover(10), false)
                col4row10.addEventListener('mouseout', () => this.hoverOut(10), false)

                let col1row11 = document.querySelector(' #features .feature:nth-of-type(11)')
                let col2row11 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(11)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(11)')
                let col3row11 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(11)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(11)')
                let col4row11 = document.querySelector(' #free_plan .feature:nth-of-type(11)')

                col1row11.addEventListener('mouseover', () => this.hover(11), false)
                col1row11.addEventListener('mouseout', () => this.hoverOut(11), false)
                col2row11.addEventListener('mouseover', () => this.hover(11), false)
                col2row11.addEventListener('mouseout', () => this.hoverOut(11), false)
                col3row11.addEventListener('mouseover', () => this.hover(11), false)
                col3row11.addEventListener('mouseout', () => this.hoverOut(11), false)
                col4row11.addEventListener('mouseover', () => this.hover(11), false)
                col4row11.addEventListener('mouseout', () => this.hoverOut(11), false)

                let col1row12 = document.querySelector(' #features .feature:nth-of-type(12)')
                let col2row12 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(12)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(12)')
                let col3row12 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(12)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(12)')
                let col4row12 = document.querySelector(' #free_plan .feature:nth-of-type(12)')

                col1row12.addEventListener('mouseover', () => this.hover(12), false)
                col1row12.addEventListener('mouseout', () => this.hoverOut(12), false)
                col2row12.addEventListener('mouseover', () => this.hover(12), false)
                col2row12.addEventListener('mouseout', () => this.hoverOut(12), false)
                col3row12.addEventListener('mouseover', () => this.hover(12), false)
                col3row12.addEventListener('mouseout', () => this.hoverOut(12), false)
                col4row12.addEventListener('mouseover', () => this.hover(12), false)
                col4row12.addEventListener('mouseout', () => this.hoverOut(12), false)

                let col1row13 = document.querySelector(' #features .feature:nth-of-type(13)')
                let col2row13 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(13)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(13)')
                let col3row13 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(13)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(13)')
                let col4row13 = document.querySelector(' #free_plan .feature:nth-of-type(13)')

                col1row13.addEventListener('mouseover', () => this.hover(13), false)
                col1row13.addEventListener('mouseout', () => this.hoverOut(13), false)
                col2row13.addEventListener('mouseover', () => this.hover(13), false)
                col2row13.addEventListener('mouseout', () => this.hoverOut(13), false)
                col3row13.addEventListener('mouseover', () => this.hover(13), false)
                col3row13.addEventListener('mouseout', () => this.hoverOut(13), false)
                col4row13.addEventListener('mouseover', () => this.hover(13), false)
                col4row13.addEventListener('mouseout', () => this.hoverOut(13), false)

                let col1row14 = document.querySelector(' #features .feature:nth-of-type(14)')
                let col2row14 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(14)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(14)')
                let col3row14 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(14)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(14)')
                let col4row14 = document.querySelector(' #free_plan .feature:nth-of-type(14)')

                col1row14.addEventListener('mouseover', () => this.hover(14), false)
                col1row14.addEventListener('mouseout', () => this.hoverOut(14), false)
                col2row14.addEventListener('mouseover', () => this.hover(14), false)
                col2row14.addEventListener('mouseout', () => this.hoverOut(14), false)
                col3row14.addEventListener('mouseover', () => this.hover(14), false)
                col3row14.addEventListener('mouseout', () => this.hoverOut(14), false)
                col4row14.addEventListener('mouseover', () => this.hover(14), false)
                col4row14.addEventListener('mouseout', () => this.hoverOut(14), false)

                let col1row15 = document.querySelector(' #features .feature:nth-of-type(15)')
                let col2row15 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(15)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(15)')
                let col3row15 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(15)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(15)')
                let col4row15 = document.querySelector(' #free_plan .feature:nth-of-type(15)')

                col1row15.addEventListener('mouseover', () => this.hover(15), false)
                col1row15.addEventListener('mouseout', () => this.hoverOut(15), false)
                col2row15.addEventListener('mouseover', () => this.hover(15), false)
                col2row15.addEventListener('mouseout', () => this.hoverOut(15), false)
                col3row15.addEventListener('mouseover', () => this.hover(15), false)
                col3row15.addEventListener('mouseout', () => this.hoverOut(15), false)
                col4row15.addEventListener('mouseover', () => this.hover(15), false)
                col4row15.addEventListener('mouseout', () => this.hoverOut(15), false)

                let col1row16 = document.querySelector(' #features .feature:nth-of-type(16)')
                let col2row16 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(16)') :
                    document.querySelector(' #essentials_monthly .feature:nth-of-type(16)')
                let col3row16 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(16)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(16)')
                let col4row16 = document.querySelector(' #free_plan .feature:nth-of-type(16)')

                col1row16.addEventListener('mouseover', () => this.hover(16), false)
                col1row16.addEventListener('mouseout', () => this.hoverOut(16), false)
                col2row16.addEventListener('mouseover', () => this.hover(16), false)
                col2row16.addEventListener('mouseout', () => this.hoverOut(16), false)
                col3row16.addEventListener('mouseover', () => this.hover(16), false)
                col3row16.addEventListener('mouseout', () => this.hoverOut(16), false)
                col4row16.addEventListener('mouseover', () => this.hover(16), false)
                col4row16.addEventListener('mouseout', () => this.hoverOut(16), false)

                let col1row17 = document.querySelector(' #features .feature:nth-of-type(17)')
                let col2row17 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(17)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(17)')
                let col3row17 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(17)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(17)')
                let col4row17 = document.querySelector(' #free_plan .feature:nth-of-type(17)')

                col1row17.addEventListener('mouseover', () => this.hover(17), false)
                col1row17.addEventListener('mouseout', () => this.hoverOut(17), false)
                col2row17.addEventListener('mouseover', () => this.hover(17), false)
                col2row17.addEventListener('mouseout', () => this.hoverOut(17), false)
                col3row17.addEventListener('mouseover', () => this.hover(17), false)
                col3row17.addEventListener('mouseout', () => this.hoverOut(17), false)
                col4row17.addEventListener('mouseover', () => this.hover(17), false)
                col4row17.addEventListener('mouseout', () => this.hoverOut(17), false)

                let col1row18 = document.querySelector(' #features .feature:nth-of-type(18)')
                let col2row18 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(18)') :
                    document.querySelector(' #essentials_monthly .feature:nth-of-type(18)')
                let col3row18 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(18)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(18)')
                let col4row18 = document.querySelector(' #free_plan .feature:nth-of-type(18)')

                col1row18.addEventListener('mouseover', () => this.hover(18), false)
                col1row18.addEventListener('mouseout', () => this.hoverOut(18), false)
                col2row18.addEventListener('mouseover', () => this.hover(18), false)
                col2row18.addEventListener('mouseout', () => this.hoverOut(18), false)
                col3row18.addEventListener('mouseover', () => this.hover(18), false)
                col3row18.addEventListener('mouseout', () => this.hoverOut(18), false)
                col4row18.addEventListener('mouseover', () => this.hover(18), false)
                col4row18.addEventListener('mouseout', () => this.hoverOut(18), false)

                let col1row19 = document.querySelector(' #features .feature:nth-of-type(19)')
                let col2row19 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(19)') :
                    document.querySelector(' #essentials_monthly .feature:nth-of-type(19)')
                let col3row19 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(19)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(19)')
                let col4row19 = document.querySelector(' #free_plan .feature:nth-of-type(19)')

                col1row19.addEventListener('mouseover', () => this.hover(19), false)
                col1row19.addEventListener('mouseout', () => this.hoverOut(19), false)
                col2row19.addEventListener('mouseover', () => this.hover(19), false)
                col2row19.addEventListener('mouseout', () => this.hoverOut(19), false)
                col3row19.addEventListener('mouseover', () => this.hover(19), false)
                col3row19.addEventListener('mouseout', () => this.hoverOut(19), false)
                col4row19.addEventListener('mouseover', () => this.hover(19), false)
                col4row19.addEventListener('mouseout', () => this.hoverOut(19), false)

                let col1row20 = document.querySelector(' #features .feature:nth-of-type(20)')
                let col2row20 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(20)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(20)')
                let col3row20 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(20)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(20)')
                let col4row20 = document.querySelector(' #free_plan .feature:nth-of-type(20)')

                col1row20.addEventListener('mouseover', () => this.hover(20), false)
                col1row20.addEventListener('mouseout', () => this.hoverOut(20), false)
                col2row20.addEventListener('mouseover', () => this.hover(20), false)
                col2row20.addEventListener('mouseout', () => this.hoverOut(20), false)
                col3row20.addEventListener('mouseover', () => this.hover(20), false)
                col3row20.addEventListener('mouseout', () => this.hoverOut(20), false)
                col4row20.addEventListener('mouseover', () => this.hover(20), false)
                col4row20.addEventListener('mouseout', () => this.hoverOut(20), false)

                let col1row21 = document.querySelector(' #features .feature:nth-of-type(21)')
                let col2row21 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(21)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(21)')
                let col3row21 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(21)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(21)')
                let col4row21 = document.querySelector(' #free_plan .feature:nth-of-type(21)')

                col1row21.addEventListener('mouseover', () => this.hover(21), false)
                col1row21.addEventListener('mouseout', () => this.hoverOut(21), false)
                col2row21.addEventListener('mouseover', () => this.hover(21), false)
                col2row21.addEventListener('mouseout', () => this.hoverOut(21), false)
                col3row21.addEventListener('mouseover', () => this.hover(21), false)
                col3row21.addEventListener('mouseout', () => this.hoverOut(21), false)
                col4row21.addEventListener('mouseover', () => this.hover(21), false)
                col4row21.addEventListener('mouseout', () => this.hoverOut(21), false)

                let col1row22 = document.querySelector(' #features .feature:nth-of-type(22)')
                let col2row22 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(22)')
                    : document.querySelector(' #essentials_monthly .feature:nth-of-type(22)')
                let col3row22 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(22)')
                    : document.querySelector(' #boost_monthly .feature:nth-of-type(22)')
                let col4row22 = document.querySelector(' #free_plan .feature:nth-of-type(22)')

                col1row22.addEventListener('mouseover', () => this.hover(22), false)
                col1row22.addEventListener('mouseout', () => this.hoverOut(22), false)
                col2row22.addEventListener('mouseover', () => this.hover(22), false)
                col2row22.addEventListener('mouseout', () => this.hoverOut(22), false)
                col3row22.addEventListener('mouseover', () => this.hover(22), false)
                col3row22.addEventListener('mouseout', () => this.hoverOut(22), false)
                col4row22.addEventListener('mouseover', () => this.hover(22), false)
                col4row22.addEventListener('mouseout', () => this.hoverOut(22), false)

            } else if (visiblePlansCount === 3) {
                //hover elements
                let col1row1 = document.querySelector(' #features .feature:nth-of-type(1)')
                let col2row1 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(1)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(1)')
                let col3row1 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(1)') : document.querySelector(' #boost_monthly .feature:nth-of-type(1)')


                col1row1.addEventListener('mouseover', () => this.hover(1), false)
                col1row1.addEventListener('mouseout', () => this.hoverOut(1), false)
                col2row1.addEventListener('mouseover', () => this.hover(1), false)
                col2row1.addEventListener('mouseout', () => this.hoverOut(1), false)
                col3row1.addEventListener('mouseover', () => this.hover(1), false)
                col3row1.addEventListener('mouseout', () => this.hoverOut(1), false)


                let col1row2 = document.querySelector(' #features .feature:nth-of-type(2)')
                let col2row2 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(2)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(2)')
                let col3row2 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(2)') : document.querySelector(' #boost_monthly .feature:nth-of-type(2)')


                col1row2.addEventListener('mouseover', () => this.hover(2), false)
                col1row2.addEventListener('mouseout', () => this.hoverOut(2), false)
                col2row2.addEventListener('mouseover', () => this.hover(2), false)
                col2row2.addEventListener('mouseout', () => this.hoverOut(2), false)
                col3row2.addEventListener('mouseover', () => this.hover(2), false)
                col3row2.addEventListener('mouseout', () => this.hoverOut(2), false)


                let col1row3 = document.querySelector(' #features .feature:nth-of-type(3)')
                let col2row3 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(3)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(3)')
                let col3row3 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(3)') : document.querySelector(' #boost_monthly .feature:nth-of-type(3)')


                col1row3.addEventListener('mouseover', () => this.hover(3), false)
                col1row3.addEventListener('mouseout', () => this.hoverOut(3), false)
                col2row3.addEventListener('mouseover', () => this.hover(3), false)
                col2row3.addEventListener('mouseout', () => this.hoverOut(3), false)
                col3row3.addEventListener('mouseover', () => this.hover(3), false)
                col3row3.addEventListener('mouseout', () => this.hoverOut(3), false)


                let col1row4 = document.querySelector(' #features .feature:nth-of-type(4)')
                let col2row4 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(4)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(4)')
                let col3row4 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(4)') : document.querySelector(' #boost_monthly .feature:nth-of-type(4)')


                col1row4.addEventListener('mouseover', () => this.hover(4), false)
                col1row4.addEventListener('mouseout', () => this.hoverOut(4), false)
                col2row4.addEventListener('mouseover', () => this.hover(4), false)
                col2row4.addEventListener('mouseout', () => this.hoverOut(4), false)
                col3row4.addEventListener('mouseover', () => this.hover(4), false)
                col3row4.addEventListener('mouseout', () => this.hoverOut(4), false)


                let col1row5 = document.querySelector(' #features .feature:nth-of-type(5)')
                let col2row5 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(5)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(5)')
                let col3row5 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(5)') : document.querySelector(' #boost_monthly .feature:nth-of-type(5)')

                col1row5.addEventListener('mouseover', () => this.hover(5), false)
                col1row5.addEventListener('mouseout', () => this.hoverOut(5), false)
                col2row5.addEventListener('mouseover', () => this.hover(5), false)
                col2row5.addEventListener('mouseout', () => this.hoverOut(5), false)
                col3row5.addEventListener('mouseover', () => this.hover(5), false)
                col3row5.addEventListener('mouseout', () => this.hoverOut(5), false)


                let col1row6 = document.querySelector(' #features .feature:nth-of-type(6)')
                let col2row6 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(6)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(6)')
                let col3row6 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(6)') : document.querySelector(' #boost_monthly .feature:nth-of-type(6)')

                col1row6.addEventListener('mouseover', () => this.hover(6), false)
                col1row6.addEventListener('mouseout', () => this.hoverOut(6), false)
                col2row6.addEventListener('mouseover', () => this.hover(6), false)
                col2row6.addEventListener('mouseout', () => this.hoverOut(6), false)
                col3row6.addEventListener('mouseover', () => this.hover(6), false)
                col3row6.addEventListener('mouseout', () => this.hoverOut(6), false)


                let col1row7 = document.querySelector(' #features .feature:nth-of-type(7)')
                let col2row7 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(7)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(7)')
                let col3row7 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(7)') : document.querySelector(' #boost_monthly .feature:nth-of-type(7)')

                col1row7.addEventListener('mouseover', () => this.hover(7), false)
                col1row7.addEventListener('mouseout', () => this.hoverOut(7), false)
                col2row7.addEventListener('mouseover', () => this.hover(7), false)
                col2row7.addEventListener('mouseout', () => this.hoverOut(7), false)
                col3row7.addEventListener('mouseover', () => this.hover(7), false)
                col3row7.addEventListener('mouseout', () => this.hoverOut(7), false)


                let col1row8 = document.querySelector(' #features .feature:nth-of-type(8)')
                let col2row8 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(8)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(8)')
                let col3row8 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(8)') : document.querySelector(' #boost_monthly .feature:nth-of-type(8)')

                col1row8.addEventListener('mouseover', () => this.hover(8), false)
                col1row8.addEventListener('mouseout', () => this.hoverOut(8), false)
                col2row8.addEventListener('mouseover', () => this.hover(8), false)
                col2row8.addEventListener('mouseout', () => this.hoverOut(8), false)
                col3row8.addEventListener('mouseover', () => this.hover(8), false)
                col3row8.addEventListener('mouseout', () => this.hoverOut(8), false)


                let col1row9 = document.querySelector(' #features .feature:nth-of-type(9)')
                let col2row9 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(9)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(9)')
                let col3row9 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(9)') : document.querySelector(' #boost_monthly .feature:nth-of-type(9)')

                col1row9.addEventListener('mouseover', () => this.hover(9), false)
                col1row9.addEventListener('mouseout', () => this.hoverOut(9), false)
                col2row9.addEventListener('mouseover', () => this.hover(9), false)
                col2row9.addEventListener('mouseout', () => this.hoverOut(9), false)
                col3row9.addEventListener('mouseover', () => this.hover(9), false)
                col3row9.addEventListener('mouseout', () => this.hoverOut(9), false)


                let col1row10 = document.querySelector(' #features .feature:nth-of-type(10)')
                let col2row10 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(10)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(10)')
                let col3row10 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(10)') : document.querySelector(' #boost_monthly .feature:nth-of-type(10)')

                col1row10.addEventListener('mouseover', () => this.hover(10), false)
                col1row10.addEventListener('mouseout', () => this.hoverOut(10), false)
                col2row10.addEventListener('mouseover', () => this.hover(10), false)
                col2row10.addEventListener('mouseout', () => this.hoverOut(10), false)
                col3row10.addEventListener('mouseover', () => this.hover(10), false)
                col3row10.addEventListener('mouseout', () => this.hoverOut(10), false)


                let col1row11 = document.querySelector(' #features .feature:nth-of-type(11)')
                let col2row11 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(11)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(11)')
                let col3row11 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(11)') : document.querySelector(' #boost_monthly .feature:nth-of-type(11)')

                col1row11.addEventListener('mouseover', () => this.hover(11), false)
                col1row11.addEventListener('mouseout', () => this.hoverOut(11), false)
                col2row11.addEventListener('mouseover', () => this.hover(11), false)
                col2row11.addEventListener('mouseout', () => this.hoverOut(11), false)
                col3row11.addEventListener('mouseover', () => this.hover(11), false)
                col3row11.addEventListener('mouseout', () => this.hoverOut(11), false)


                let col1row12 = document.querySelector(' #features .feature:nth-of-type(12)')
                let col2row12 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(12)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(12)')
                let col3row12 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(12)') : document.querySelector(' #boost_monthly .feature:nth-of-type(12)')

                col1row12.addEventListener('mouseover', () => this.hover(12), false)
                col1row12.addEventListener('mouseout', () => this.hoverOut(12), false)
                col2row12.addEventListener('mouseover', () => this.hover(12), false)
                col2row12.addEventListener('mouseout', () => this.hoverOut(12), false)
                col3row12.addEventListener('mouseover', () => this.hover(12), false)
                col3row12.addEventListener('mouseout', () => this.hoverOut(12), false)


                let col1row13 = document.querySelector(' #features .feature:nth-of-type(13)')
                let col2row13 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(13)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(13)')
                let col3row13 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(13)') : document.querySelector(' #boost_monthly .feature:nth-of-type(13)')

                col1row13.addEventListener('mouseover', () => this.hover(13), false)
                col1row13.addEventListener('mouseout', () => this.hoverOut(13), false)
                col2row13.addEventListener('mouseover', () => this.hover(13), false)
                col2row13.addEventListener('mouseout', () => this.hoverOut(13), false)
                col3row13.addEventListener('mouseover', () => this.hover(13), false)
                col3row13.addEventListener('mouseout', () => this.hoverOut(13), false)


                let col1row14 = document.querySelector(' #features .feature:nth-of-type(14)')
                let col2row14 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(14)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(14)')
                let col3row14 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(14)') : document.querySelector(' #boost_monthly .feature:nth-of-type(14)')

                col1row14.addEventListener('mouseover', () => this.hover(14), false)
                col1row14.addEventListener('mouseout', () => this.hoverOut(14), false)
                col2row14.addEventListener('mouseover', () => this.hover(14), false)
                col2row14.addEventListener('mouseout', () => this.hoverOut(14), false)
                col3row14.addEventListener('mouseover', () => this.hover(14), false)
                col3row14.addEventListener('mouseout', () => this.hoverOut(14), false)


                let col1row15 = document.querySelector(' #features .feature:nth-of-type(15)')
                let col2row15 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(15)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(15)')
                let col3row15 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(15)') : document.querySelector(' #boost_monthly .feature:nth-of-type(15)')

                col1row15.addEventListener('mouseover', () => this.hover(15), false)
                col1row15.addEventListener('mouseout', () => this.hoverOut(15), false)
                col2row15.addEventListener('mouseover', () => this.hover(15), false)
                col2row15.addEventListener('mouseout', () => this.hoverOut(15), false)
                col3row15.addEventListener('mouseover', () => this.hover(15), false)
                col3row15.addEventListener('mouseout', () => this.hoverOut(15), false)


                let col1row16 = document.querySelector(' #features .feature:nth-of-type(16)')
                let col2row16 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(16)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(16)')
                let col3row16 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(16)') : document.querySelector(' #boost_monthly .feature:nth-of-type(16)')

                col1row16.addEventListener('mouseover', () => this.hover(16), false)
                col1row16.addEventListener('mouseout', () => this.hoverOut(16), false)
                col2row16.addEventListener('mouseover', () => this.hover(16), false)
                col2row16.addEventListener('mouseout', () => this.hoverOut(16), false)
                col3row16.addEventListener('mouseover', () => this.hover(16), false)
                col3row16.addEventListener('mouseout', () => this.hoverOut(16), false)


                let col1row17 = document.querySelector(' #features .feature:nth-of-type(17)')
                let col2row17 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(17)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(17)')
                let col3row17 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(17)') : document.querySelector(' #boost_monthly .feature:nth-of-type(17)')

                col1row17.addEventListener('mouseover', () => this.hover(17), false)
                col1row17.addEventListener('mouseout', () => this.hoverOut(17), false)
                col2row17.addEventListener('mouseover', () => this.hover(17), false)
                col2row17.addEventListener('mouseout', () => this.hoverOut(17), false)
                col3row17.addEventListener('mouseover', () => this.hover(17), false)
                col3row17.addEventListener('mouseout', () => this.hoverOut(17), false)


                let col1row18 = document.querySelector(' #features .feature:nth-of-type(18)')
                let col2row18 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(18)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(18)')
                let col3row18 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(18)') : document.querySelector(' #boost_monthly .feature:nth-of-type(18)')

                col1row18.addEventListener('mouseover', () => this.hover(18), false)
                col1row18.addEventListener('mouseout', () => this.hoverOut(18), false)
                col2row18.addEventListener('mouseover', () => this.hover(18), false)
                col2row18.addEventListener('mouseout', () => this.hoverOut(18), false)
                col3row18.addEventListener('mouseover', () => this.hover(18), false)
                col3row18.addEventListener('mouseout', () => this.hoverOut(18), false)


                let col1row19 = document.querySelector(' #features .feature:nth-of-type(19)')
                let col2row19 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(19)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(19)')
                let col3row19 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(19)') : document.querySelector(' #boost_monthly .feature:nth-of-type(19)')

                col1row19.addEventListener('mouseover', () => this.hover(19), false)
                col1row19.addEventListener('mouseout', () => this.hoverOut(19), false)
                col2row19.addEventListener('mouseover', () => this.hover(19), false)
                col2row19.addEventListener('mouseout', () => this.hoverOut(19), false)
                col3row19.addEventListener('mouseover', () => this.hover(19), false)
                col3row19.addEventListener('mouseout', () => this.hoverOut(19), false)


                let col1row20 = document.querySelector(' #features .feature:nth-of-type(20)')
                let col2row20 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(20)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(20)')
                let col3row20 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(20)') : document.querySelector(' #boost_monthly .feature:nth-of-type(20)')

                col1row20.addEventListener('mouseover', () => this.hover(20), false)
                col1row20.addEventListener('mouseout', () => this.hoverOut(20), false)
                col2row20.addEventListener('mouseover', () => this.hover(20), false)
                col2row20.addEventListener('mouseout', () => this.hoverOut(20), false)
                col3row20.addEventListener('mouseover', () => this.hover(20), false)
                col3row20.addEventListener('mouseout', () => this.hoverOut(20), false)

                let col1row21 = document.querySelector(' #features .feature:nth-of-type(21)')
                let col2row21 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(21)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(21)')
                let col3row21 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(21)') : document.querySelector(' #boost_monthly .feature:nth-of-type(21)')

                col1row21.addEventListener('mouseover', () => this.hover(21), false)
                col1row21.addEventListener('mouseout', () => this.hoverOut(21), false)
                col2row21.addEventListener('mouseover', () => this.hover(21), false)
                col2row21.addEventListener('mouseout', () => this.hoverOut(21), false)
                col3row21.addEventListener('mouseover', () => this.hover(21), false)
                col3row21.addEventListener('mouseout', () => this.hoverOut(21), false)

                let col1row22 = document.querySelector(' #features .feature:nth-of-type(22)')
                let col2row22 = this.state.planPeriod ? document.querySelector(' #essentials_yearly .feature:nth-of-type(22)') : document.querySelector(' #essentials_monthly .feature:nth-of-type(22)')
                let col3row22 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(22)') : document.querySelector(' #boost_monthly .feature:nth-of-type(22)')

                col1row22.addEventListener('mouseover', () => this.hover(22), false)
                col1row22.addEventListener('mouseout', () => this.hoverOut(22), false)
                col2row22.addEventListener('mouseover', () => this.hover(22), false)
                col2row22.addEventListener('mouseout', () => this.hoverOut(22), false)
                col3row22.addEventListener('mouseover', () => this.hover(22), false)
                col3row22.addEventListener('mouseout', () => this.hoverOut(22), false)


            } else if (visiblePlansCount === 2) {
                //hover elements
                let col1row1 = document.querySelector(' #features .feature:nth-of-type(1)')
                let col2row1 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(1)') : document.querySelector(' #boost_monthly .feature:nth-of-type(1)')


                col1row1.addEventListener('mouseover', () => this.hover(1), false)
                col1row1.addEventListener('mouseout', () => this.hoverOut(1), false)
                col2row1.addEventListener('mouseover', () => this.hover(1), false)
                col2row1.addEventListener('mouseout', () => this.hoverOut(1), false)


                let col1row2 = document.querySelector(' #features .feature:nth-of-type(2)')
                let col2row2 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(2)') : document.querySelector(' #boost_monthly .feature:nth-of-type(2)')


                col1row2.addEventListener('mouseover', () => this.hover(2), false)
                col1row2.addEventListener('mouseout', () => this.hoverOut(2), false)
                col2row2.addEventListener('mouseover', () => this.hover(2), false)
                col2row2.addEventListener('mouseout', () => this.hoverOut(2), false)


                let col1row3 = document.querySelector(' #features .feature:nth-of-type(3)')
                let col2row3 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(3)') : document.querySelector(' #boost_monthly .feature:nth-of-type(3)')


                col1row3.addEventListener('mouseover', () => this.hover(3), false)
                col1row3.addEventListener('mouseout', () => this.hoverOut(3), false)
                col2row3.addEventListener('mouseover', () => this.hover(3), false)
                col2row3.addEventListener('mouseout', () => this.hoverOut(3), false)


                let col1row4 = document.querySelector(' #features .feature:nth-of-type(4)')
                let col2row4 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(4)') : document.querySelector(' #boost_monthly .feature:nth-of-type(4)')


                col1row4.addEventListener('mouseover', () => this.hover(4), false)
                col1row4.addEventListener('mouseout', () => this.hoverOut(4), false)
                col2row4.addEventListener('mouseover', () => this.hover(4), false)
                col2row4.addEventListener('mouseout', () => this.hoverOut(4), false)


                let col1row5 = document.querySelector(' #features .feature:nth-of-type(5)')
                let col2row5 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(5)') : document.querySelector(' #boost_monthly .feature:nth-of-type(5)')


                col1row5.addEventListener('mouseover', () => this.hover(5), false)
                col1row5.addEventListener('mouseout', () => this.hoverOut(5), false)
                col2row5.addEventListener('mouseover', () => this.hover(5), false)
                col2row5.addEventListener('mouseout', () => this.hoverOut(5), false)


                let col1row6 = document.querySelector(' #features .feature:nth-of-type(6)')
                let col2row6 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(6)') : document.querySelector(' #boost_monthly .feature:nth-of-type(6)')


                col1row6.addEventListener('mouseover', () => this.hover(6), false)
                col1row6.addEventListener('mouseout', () => this.hoverOut(6), false)
                col2row6.addEventListener('mouseover', () => this.hover(6), false)
                col2row6.addEventListener('mouseout', () => this.hoverOut(6), false)


                let col1row7 = document.querySelector(' #features .feature:nth-of-type(7)')
                let col2row7 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(7)') : document.querySelector(' #boost_monthly .feature:nth-of-type(7)')


                col1row7.addEventListener('mouseover', () => this.hover(7), false)
                col1row7.addEventListener('mouseout', () => this.hoverOut(7), false)
                col2row7.addEventListener('mouseover', () => this.hover(7), false)
                col2row7.addEventListener('mouseout', () => this.hoverOut(7), false)


                let col1row8 = document.querySelector(' #features .feature:nth-of-type(8)')
                let col2row8 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(8)') : document.querySelector(' #boost_monthly .feature:nth-of-type(8)')

                col1row8.addEventListener('mouseover', () => this.hover(8), false)
                col1row8.addEventListener('mouseout', () => this.hoverOut(8), false)
                col2row8.addEventListener('mouseover', () => this.hover(8), false)
                col2row8.addEventListener('mouseout', () => this.hoverOut(8), false)


                let col1row9 = document.querySelector(' #features .feature:nth-of-type(9)')
                let col2row9 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(9)') : document.querySelector(' #boost_monthly .feature:nth-of-type(9)')

                col1row9.addEventListener('mouseover', () => this.hover(9), false)
                col1row9.addEventListener('mouseout', () => this.hoverOut(9), false)
                col2row9.addEventListener('mouseover', () => this.hover(9), false)
                col2row9.addEventListener('mouseout', () => this.hoverOut(9), false)

                let col1row10 = document.querySelector(' #features .feature:nth-of-type(10)')
                let col2row10 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(10)') : document.querySelector(' #boost_monthly .feature:nth-of-type(10)')

                col1row10.addEventListener('mouseover', () => this.hover(10), false)
                col1row10.addEventListener('mouseout', () => this.hoverOut(10), false)
                col2row10.addEventListener('mouseover', () => this.hover(10), false)
                col2row10.addEventListener('mouseout', () => this.hoverOut(10), false)

                let col1row11 = document.querySelector(' #features .feature:nth-of-type(11)')
                let col2row11 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(11)') : document.querySelector(' #boost_monthly .feature:nth-of-type(11)')


                col1row11.addEventListener('mouseover', () => this.hover(11), false)
                col1row11.addEventListener('mouseout', () => this.hoverOut(11), false)
                col2row11.addEventListener('mouseover', () => this.hover(11), false)
                col2row11.addEventListener('mouseout', () => this.hoverOut(11), false)


                let col1row12 = document.querySelector(' #features .feature:nth-of-type(12)')
                let col2row12 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(12)') : document.querySelector(' #boost_monthly .feature:nth-of-type(12)')


                col1row12.addEventListener('mouseover', () => this.hover(12), false)
                col1row12.addEventListener('mouseout', () => this.hoverOut(12), false)
                col2row12.addEventListener('mouseover', () => this.hover(12), false)
                col2row12.addEventListener('mouseout', () => this.hoverOut(12), false)


                let col1row13 = document.querySelector(' #features .feature:nth-of-type(13)')
                let col2row13 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(13)') : document.querySelector(' #boost_monthly .feature:nth-of-type(13)')

                col1row13.addEventListener('mouseover', () => this.hover(13), false)
                col1row13.addEventListener('mouseout', () => this.hoverOut(13), false)
                col2row13.addEventListener('mouseover', () => this.hover(13), false)
                col2row13.addEventListener('mouseout', () => this.hoverOut(13), false)


                let col1row14 = document.querySelector(' #features .feature:nth-of-type(14)')
                let col2row14 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(14)') : document.querySelector(' #boost_monthly .feature:nth-of-type(14)')

                col1row14.addEventListener('mouseover', () => this.hover(14), false)
                col1row14.addEventListener('mouseout', () => this.hoverOut(14), false)
                col2row14.addEventListener('mouseover', () => this.hover(14), false)
                col2row14.addEventListener('mouseout', () => this.hoverOut(14), false)


                let col1row15 = document.querySelector(' #features .feature:nth-of-type(15)')
                let col2row15 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(15)') : document.querySelector(' #boost_monthly .feature:nth-of-type(15)')


                col1row15.addEventListener('mouseover', () => this.hover(15), false)
                col1row15.addEventListener('mouseout', () => this.hoverOut(15), false)
                col2row15.addEventListener('mouseover', () => this.hover(15), false)
                col2row15.addEventListener('mouseout', () => this.hoverOut(15), false)


                let col1row16 = document.querySelector(' #features .feature:nth-of-type(16)')
                let col2row16 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(16)') : document.querySelector(' #boost_monthly .feature:nth-of-type(16)')


                col1row16.addEventListener('mouseover', () => this.hover(16), false)
                col1row16.addEventListener('mouseout', () => this.hoverOut(16), false)
                col2row16.addEventListener('mouseover', () => this.hover(16), false)
                col2row16.addEventListener('mouseout', () => this.hoverOut(16), false)


                let col1row17 = document.querySelector(' #features .feature:nth-of-type(17)')
                let col2row17 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(17)') : document.querySelector(' #boost_monthly .feature:nth-of-type(17)')

                col1row17.addEventListener('mouseover', () => this.hover(17), false)
                col1row17.addEventListener('mouseout', () => this.hoverOut(17), false)
                col2row17.addEventListener('mouseover', () => this.hover(17), false)
                col2row17.addEventListener('mouseout', () => this.hoverOut(17), false)


                let col1row18 = document.querySelector(' #features .feature:nth-of-type(18)')
                let col2row18 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(18)') : document.querySelector(' #boost_monthly .feature:nth-of-type(18)')


                col1row18.addEventListener('mouseover', () => this.hover(18), false)
                col1row18.addEventListener('mouseout', () => this.hoverOut(18), false)
                col2row18.addEventListener('mouseover', () => this.hover(18), false)
                col2row18.addEventListener('mouseout', () => this.hoverOut(18), false)

                let col1row19 = document.querySelector(' #features .feature:nth-of-type(19)')
                let col2row19 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(19)') : document.querySelector(' #boost_monthly .feature:nth-of-type(19)')

                col1row19.addEventListener('mouseover', () => this.hover(19), false)
                col1row19.addEventListener('mouseout', () => this.hoverOut(19), false)
                col2row19.addEventListener('mouseover', () => this.hover(19), false)
                col2row19.addEventListener('mouseout', () => this.hoverOut(19), false)

                let col1row20 = document.querySelector(' #features .feature:nth-of-type(20)')
                let col2row20 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(20)') : document.querySelector(' #boost_monthly .feature:nth-of-type(20)')


                col1row20.addEventListener('mouseover', () => this.hover(20), false)
                col1row20.addEventListener('mouseout', () => this.hoverOut(20), false)
                col2row20.addEventListener('mouseover', () => this.hover(20), false)
                col2row20.addEventListener('mouseout', () => this.hoverOut(20), false)

                let col1row21 = document.querySelector(' #features .feature:nth-of-type(21)')
                let col2row21 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(21)') : document.querySelector(' #boost_monthly .feature:nth-of-type(21)')

                col1row21.addEventListener('mouseover', () => this.hover(21), false)
                col1row21.addEventListener('mouseout', () => this.hoverOut(21), false)
                col2row21.addEventListener('mouseover', () => this.hover(21), false)
                col2row21.addEventListener('mouseout', () => this.hoverOut(21), false)

                let col1row22 = document.querySelector(' #features .feature:nth-of-type(22)')
                let col2row22 = this.state.planPeriod ? document.querySelector(' #boost_yearly .feature:nth-of-type(22)') : document.querySelector(' #boost_monthly .feature:nth-of-type(22)')


                col1row22.addEventListener('mouseover', () => this.hover(22), false)
                col1row22.addEventListener('mouseout', () => this.hoverOut(22), false)
                col2row22.addEventListener('mouseover', () => this.hover(22), false)
                col2row22.addEventListener('mouseout', () => this.hoverOut(22), false)

            }

        }
    }

    hover = (n) => {
        document.querySelector('#features .feature:nth-of-type(' + n + ')').style.backgroundColor = '#ebf3f7';
        document.querySelector(this.state.planPeriod ? '#boost_yearly .feature:nth-of-type(' + n + ')' : '#boost_monthly .feature:nth-of-type(' + n + ')').style.backgroundColor = '#ebf3f7';

        if (this.state.planPeriod) {
            if (document.querySelector('#essentials_yearly')) {
                document.querySelector(this.state.planPeriod ? '#essentials_yearly .feature:nth-of-type(' + n + ')' : '#essentials_monthly .feature:nth-of-type(' + n + ')').style.backgroundColor = '#ebf3f7';
            } else {
                if (document.querySelector('#essentials_monthly')) {
                    document.querySelector(this.state.planPeriod ? '#essentials_yearly .feature:nth-of-type(' + n + ')' : '#essentials_monthly .feature:nth-of-type(' + n + ')').style.backgroundColor = '#ebf3f7';
                }
            }
        }


        if (document.querySelector('#free_plan')) {
            document.querySelector('#free_plan .feature:nth-of-type(' + n + ')').style.backgroundColor = '#ebf3f7';
        }


        if (document.querySelector('.grey-plan')) {
            document.querySelector('.grey-plan .feature:nth-of-type(' + n + ')').style.backgroundColor = '#ebf3f7';
        }

    }

    hoverOut(n) {

        document.querySelector('#features .feature:nth-of-type(' + n + ')').style.backgroundColor = '#fff';

        document.querySelector(this.state.planPeriod ? '#boost_yearly .feature:nth-of-type(' + n + ')' : '#boost_monthly .feature:nth-of-type(' + n + ')').style.backgroundColor = '#fff';

        if (this.state.planPeriod) {
            if (document.querySelector('#essentials_yearly')) {
                document.querySelector(this.state.planPeriod ? '#essentials_yearly .feature:nth-of-type(' + n + ')' : '#essentials_monthly .feature:nth-of-type(' + n + ')').style.backgroundColor = '#F5FBFE';
            } else {
                if (document.querySelector('#essentials_monthly')) {
                    document.querySelector(this.state.planPeriod ? '#essentials_yearly .feature:nth-of-type(' + n + ')' : '#essentials_monthly .feature:nth-of-type(' + n + ')').style.backgroundColor = '#F5FBFE';
                }
            }
        }
        if (document.querySelector('#free_plan')) {
            document.querySelector('#free_plan .feature:nth-of-type(' + n + ')').style.backgroundColor = '#fff';
        }

        if (document.querySelector('.grey-plan')) {
            document.querySelector('.grey-plan .feature:nth-of-type(' + n + ')').style.backgroundColor = '#e4e4e4';
        }
    }

    componentDidMount = async () => {
        this.setState({
            overlayIsOpen: this.props.showModal,
        })


        if ((this.props.user.name === ' ') || !this.props.user.name) {
            await this.props.updateUserFromServer()
        }
        let result
        try {
            result = await http.get('api/emitto_plans/product/emitto_plans', {headers: {authorization: getJwt()}});
            //console.log('stripe plans: ', result)
            await this.setState({stripePlans: result.data.data})
            await this.getSelectedPlan()
            // console.log('get_stripe_plans: ', this.state.stripePlans)
        } catch (e) {
            toastr.error("Couldn't get stripe plans.")
        }

        let chosenPlan = this.state.planPeriod ? 'boost_yearly' : 'boost_monthly'
        let chosenPlanFull = this.state.stripePlans.find(
            stripePlan => {
                return stripePlan.plan_id === chosenPlan
            }
        )
        await this.setState({
            chosenPlan,
            chosenPlanFull,

        })

        // calculate remaining price for possible essentials yearly to boost yearly upgrade
        if (this.state.user && result) {
            await this.calculateRemainingPrice(result.data.data)
        }

    }
    hoverListeners = () => {
        setTimeout(this.hoverIf, 2000)

    }

    componentDidUpdate = async () => {

        if (this.state.overlayIsOpen !== this.props.showModal) {
            //console.log('prevProps: ', prevProps)
            //console.log('component did update')
            //console.log('cdu plan: ', this.props.plan)
            if (this.state.clicked === false) {
                // console.log('hoverListeners run')
                await this.hoverListeners();
            }
            this.setState({
                overlayIsOpen: this.props.showModal,
                title: this.props.title,
                content: this.props.content,
                plan: this.props.plan
            })
        }
        if (this.state.selectedPlan !== this.props.plan) {
            await this.setState({selectedPlan: this.props.plan})
        }

    }


    render() {

        let stripePlans;
        if (this.state.stripePlans) {
            let freePlan = this.state.stripePlans.find(plan => {
                return plan.name === "Free Forever"
            })
            if (this.state.planPeriod) {
                stripePlans = this.state.stripePlans.filter(plan => {
                    return plan.interval === 'year'
                })
                stripePlans = stripePlans.slice(0).reverse()
                stripePlans = [...stripePlans, freePlan]
                stripePlans = stripePlans.slice(0).reverse()

            } else {
                stripePlans = this.state.stripePlans.filter(plan => {
                    return plan.interval === 'month'
                })

            }

            //console.log('stripePlans render :', stripePlans);
        }
        return (
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER}
                isOpen={this.state.overlayIsOpen}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                    // transform: 'scale(0.8)'
                }}
            >
                <div className="modal-field upsell-modal-field"
                     style={{
                         width: this.props.width || '100%',
                         maxWidth: this.props.maxWidth || '100%',
                     }}>

                    <div className="onboarding-panel ">
                        <h2 className='text-center upsell-title m-lg-b'>
                            {
                                this.state.title && this.state.title !== ''
                                    ?
                                    this.state.title :
                                    'This is a PRO feature!'
                            }
                        </h2>

                        <p className='m-lg-b text-center'>
                            {
                                this.state.content && this.state.content !== ''
                                    ?
                                    this.state.content :
                                    'Personalization is not available on your current plan!\n' +
                                    'Check out the plans and features below and choose the one that suits\n' +
                                    'your needs.\n' +
                                    'Our team is available from the chat if you need any assistance.'
                            }
                        </p>
                        <div className='pricing-wrapper text-center'>
                            <div className='text-center'>
                                <h1 className='text-center'>Subscription Plans</h1>

                            </div>
                            {!this.state.selectedPlan.includes('yearly') ?
                                <div className='m-xl-b'>
                                    <div className="choose-period m-m-b">
                                        <div className="switch-container">
                                            <div className="save-label">
                                                Save 20%
                                            </div>
                                            <span>Monthly</span>
                                            <label className="plan-switch" htmlFor="checkbox-3">
                                                <input
                                                    checked={this.state.planPeriod || false}
                                                    onClick={this.planPeriodToggle}
                                                    type="checkbox"
                                                    id="checkbox-3"
                                                />
                                                <div className="plan-slider plan-round"></div>
                                            </label>
                                            <span>Yearly</span>
                                        </div>
                                    </div>

                                    {!this.state.planPeriod ?
                                        this.state.selectedPlan.includes('essentials') ?
                                            <span>Switch to yearly subscription if you want to subscribe to our
                                                Essentials yearly plan.</span>
                                            : this.state.selectedPlan.includes('boost') ?
                                                <span>Switch to yearly subscription if you want to subscribe to our Premium
                                                    yearly plan.</span>
                                                : ''
                                        : ''
                                    }
                                </div>
                                :
                                <div className='m-xl-b'>
                                    <div className="choose-period grey-choose-period">
                                        <div className="switch-container">
                                            <div className="save-label">
                                                Save 20%
                                            </div>
                                            <span>Monthly</span>
                                            <label className="plan-switch" htmlFor="checkbox-3">
                                                <input
                                                    disabled
                                                    checked={this.state.planPeriod}
                                                    type="checkbox"
                                                    id="checkbox-3"/>
                                                <div className="plan-slider plan-round"></div>
                                            </label>
                                            <span>Yearly</span>
                                        </div>
                                        {this.state.selectedPlan !== '' && this.state.selectedPlan.includes('yearly') ?
                                            <p className='downgrade-message'>If you want to downgrade to a monthly
                                                subscription, you should cancel your
                                                subscription in Billing/Subscriptions first.</p>
                                            :
                                            ''
                                        }
                                    </div>

                                </div>
                            }

                            <div id="big-screen">
                                <div className="plans-container">
                                    <div id='features'>
                                        <div className="feature-rows">
                                            <div className="feature first-row"><i className="fas fa-check"></i>All
                                                Channels
                                            </div>
                                            <div className="feature feature-sms"><i className="fas fa-comment-dots"></i>SMS
                                                <div className="tooltip"> ! <span
                                                    className="tooltiptext"> Price per message depends on the
                                                    country.</span>
                                                </div>
                                            </div>
                                            <div className="feature feature-viber"><i className="fab fa-viber"></i>Viber
                                                <div className="tooltip"> ! <span
                                                    className="tooltiptext">Price per message depends on the
                                                    country.</span>
                                                </div>
                                            </div>
                                            <div className="feature feature-webpush"><i className="fas fa-bell"></i>Web
                                                Push
                                                <div className="tooltip"> ! <span
                                                    className="tooltiptext">Billed per 1000 messages.</span>
                                                </div>
                                            </div>
                                            <div className="feature feature-messenger"><i
                                                className="fab fa-facebook-messenger"></i>Messenger
                                                <div className="tooltip"> ! <span
                                                    className="tooltiptext">Billed per 1000 messages.</span>
                                                </div>
                                            </div>
                                            <div className="feature"><i className="fas fa-user-check"></i>Contacts &
                                                Subscribers
                                            </div>
                                            <div className="feature"><i className="fas fa-user-friends"></i>Team Members
                                            </div>
                                            <div className="feature"><i className="fas fa-chart-pie"></i>Detailed
                                                Analytics
                                            </div>
                                            <div className="feature"><i className="fas fa-ad"></i>Ads Manager
                                                <div className="tooltip"> ! <span
                                                    className="tooltiptext">Create Facebook Messenger Subscriber
                                                    Acquisition Campaign right from Emitto. </span>
                                                </div>
                                            </div>
                                            <div className="feature"><i className="fab fa-wordpress"></i>WordPress
                                                Plugin
                                                <div className="tooltip"> ! <span
                                                    className="tooltiptext">Get started with Web Push Notifications in
                                                    minutes by simply installing Emitto Plugin on your website. </span>
                                                </div>
                                            </div>
                                            <div className="feature"><i className="fas fa-history"></i>Campaign History
                                            </div>
                                            <div className="feature"><i className="fas fa-history"></i>Log Retention
                                            </div>
                                            <div className="feature"><i className="fas fa-link"></i>URL Shortener with
                                                Analytics
                                            </div>
                                            <div className="feature"><i className="fas fa-lock"></i>Data Privacy
                                            </div>
                                            <div className="feature"><i className="fas fa-child"></i>Support
                                            </div>


                                            <div className="feature"><i className="fas fa-map-signs"></i>Dedicated
                                                Onboarding
                                                <div className="tooltip"> ! <span
                                                    className="tooltiptext">1-on-1 onboarding session with our founder
                                                    to help you get the most out of Emitto.
                                                </span>
                                                </div>
                                            </div>


                                            <div className="feature"><i className="fas fa-compress"></i>Content Curation
                                                <div className="tooltip"> ! <span
                                                    className="tooltiptext">Accumulate newly published content from
                                                    multiple sources and send them to your audience with one
                                                    click. </span>
                                                </div>
                                            </div>
                                            <div className="feature"><i className="fas fa-clipboard-check"></i>Branding
                                                Removal
                                                <div className="tooltip"> ! <span
                                                    className="tooltiptext">Remove Emitto branding from your
                                                    campaigns.</span>
                                                </div>
                                            </div>
                                            <div className="feature"><i className="fas fa-magic"></i>Automations
                                                <div className="tooltip"> ! <span
                                                    className="tooltiptext">RSS to Web Push - Zero-click
                                                    Automation. </span>
                                                </div>
                                            </div>
                                            <div className="feature"><i className="fas fa-fingerprint"></i>Personalized
                                                Messages
                                                <div className="tooltip"> ! <span
                                                    className="tooltiptext">Personalize your messages by using tags such
                                                    are 'First Name', 'Last Name' or 'Company'.</span>
                                                </div>
                                            </div>
                                            <div className="feature"><i className="fas fa-tag"></i>Audience Segmentation
                                                <div className="tooltip"> ! <span
                                                    className="tooltiptext">Segment your audience by their demographics
                                                    or interests in details, such are the country they are from, gender
                                                    or consumer habits. </span>
                                                </div>
                                            </div>
                                            <div className="feature"><i className="fas fa-pen-alt"></i>Service Level
                                                Agreement
                                            </div>
                                        </div>
                                    </div>
                                    {stripePlans[0] !== undefined ?

                                        stripePlans.slice(0).map(plan => {
                                                return <React.Fragment key={plan.plan_id + '_mobile'}>
                                                    {this.state.selectedPlan && this.state.selectedPlan.includes('boost') ?

                                                        this.state.planPeriod ?
                                                            plan.plan_id.includes('free') || plan.plan_id.includes('essentials') ? '' :
                                                                <div id={plan.plan_id}

                                                                     className={this.state.selectedPlan === plan.plan_id ?
                                                                         'plan grey-plan' : 'plan'
                                                                     }
                                                                >
                                                                    <h2 className="title">
                                                                        {plan.name}
                                                                    </h2>
                                                                    <div className="price-container">
                                                                        <div className="plan-price">


                                                                            {plan.interval === 'year' ?
                                                                                <React.Fragment>
                                                                                    {plan.plan_id.includes('boost') ?
                                                                                        <div className='old-month-price'>
                                                                                            <span>$300</span>
                                                                                        </div>
                                                                                        :
                                                                                        plan.plan_id.includes('essentials') ?
                                                                                            <div
                                                                                                className='old-month-price'>
                                                                                                <span>$100</span>
                                                                                            </div>
                                                                                            :
                                                                                            ''
                                                                                    }
                                                                                    <div className="save-label">
                                                                                        Save 20%
                                                                                    </div>
                                                                                    <div className='old-price'>
                                                                                    </div>
                                                                                    <div className="yearly-label">
                                                                                        billed annually
                                                                                    </div>
                                                                                </React.Fragment>
                                                                                :
                                                                                ''
                                                                            }
                                                                            <span className='currency'>$</span><span
                                                                            className='price'>
                                                                            {/*{*/}
                                                                            {/*this.state.planPeriod ?*/}
                                                                            {/*plan.price.substring(0, plan.price.length - 1) / 12*/}
                                                                            {/*:*/}
                                                                            {/*plan.price.substring(0, plan.price.length - 1)*/}

                                                                            {/*}*/}
                                                                            {
                                                                                this.state.planPeriod ?
                                                                                    plan.price.substring(0, plan.price.length - 1) * 0.8 / 12
                                                                                    :
                                                                                    plan.price.substring(0, plan.price.length - 1)
                                                                            }
                                                                        </span>
                                                                            <span className='plan-period'>/month</span>
                                                                        </div>
                                                                        <div className="feature-rows">
                                                                            <div className="feature"><i
                                                                                className="fas fa-check"></i>
                                                                            </div>
                                                                            <div className="feature">
                                                                                <span className='text-bold'>
                                                                                    $ {plan.platform_limits.sms.price}
                                                                                </span>
                                                                                <span className='price-list'>per SMS
                                                                                    (US)</span>
                                                                            </div>
                                                                            <div className="feature">
                                                                                <span className='text-bold'>
                                                                                    $ {plan.platform_limits.vib.price}

                                                                                </span>
                                                                                <span className='price-list'>per Message
                                                                                    (US)</span>
                                                                            </div>
                                                                            <div className="feature">
                                                                                <span className='text-bold'>

                                                                                    {
                                                                                        plan.plan_id.includes('free') ?
                                                                                            plan.platform_limits.wp.credits :
                                                                                            '$ ' + (plan.platform_limits.wp.price / 1000).toFixed(4)
                                                                                    }

                                                                                </span>
                                                                                <span
                                                                                    className='price-list'>
                                                                                    {
                                                                                        plan.plan_id.includes('free') ?
                                                                                            'Free Notifications Monthly' :
                                                                                            'Per Message'
                                                                                    }
                                                                                </span>
                                                                            </div>
                                                                            <div className="feature">
                                                                                <span className='text-bold'>
                                                                                    {/*{plan.plan_id.includes('free') ?*/}
                                                                                    {/*    plan.platform_limits.fb.credits :*/}
                                                                                    {'$ ' + (plan.platform_limits.fb.price / 1000).toFixed(4)}
                                                                                    {/*}*/}
                                                                                </span>
                                                                                <span
                                                                                    className='price-list'> {
                                                                                    // plan.plan_id.includes('free') ?
                                                                                    //     'Free Messages Monthly' :
                                                                                    'Per Message'
                                                                                }
                                                                                < /span>
                                                                            </div>
                                                                            <div className="feature">Unlimited</div>
                                                                            <div
                                                                                className="feature">{plan.team_members}</div>
                                                                            <div
                                                                                className="feature">{plan.additional_features.detailed_analytics === 1 ?
                                                                                <i className="fas fa-check"></i> :
                                                                                <i className="fas fa-times"></i>}</div>
                                                                            <div
                                                                                className="feature">{plan.additional_features.ads_manager === 1 ?
                                                                                <i className="fas fa-check"></i> :
                                                                                <i className="fas fa-times"></i>}</div>
                                                                            <div
                                                                                className="feature">{plan.additional_features.wpress_plugin === 1 ?
                                                                                <i className="fas fa-check"></i> :
                                                                                <i className="fas fa-times"></i>}</div>
                                                                            <div
                                                                                className="feature">{plan.campaign_history}</div>

                                                                            <div
                                                                                className="feature">{plan.log_retention}</div>
                                                                            <div
                                                                                className="feature">{plan.url_shortener.name}
                                                                                <div className="tooltip"> ! <span
                                                                                    className="tooltiptext">
                                                                                    {plan.url_shortener.description}
                                                                                </span>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                className="feature">{plan.data_privacy}</div>

                                                                            <div className="feature">{plan.support}</div>
                                                                            <div
                                                                                className="feature">{plan.dedicated_onboarding === null ?
                                                                                <i className='fas fa-times'></i> : plan.dedicated_onboarding}</div>
                                                                            <div
                                                                                className="feature">{plan.content_curation === null ?
                                                                                <i className="fas fa-times"></i> : plan.content_curation}</div>
                                                                            <div
                                                                                className="feature">{plan.additional_features.branding === 1 ?
                                                                                <i className="fas fa-times"></i> :
                                                                                <i className="fas fa-check"></i>
                                                                            }
                                                                            </div>
                                                                            <div className="feature">
                                                                                {
                                                                                    plan.content_automation === 1 ?
                                                                                        <i className="fas fa-check"></i>
                                                                                        :
                                                                                        <i className="fas fa-times"></i>

                                                                                }
                                                                            </div>
                                                                            <div className="feature">
                                                                                {
                                                                                    plan.personalization === 1 ?
                                                                                        <i className="fas fa-check"></i>
                                                                                        :
                                                                                        <i className="fas fa-times"></i>
                                                                                }
                                                                            </div>
                                                                            <div className="feature">
                                                                                {
                                                                                    plan.tags_segmentation === 1 ?
                                                                                        <i className="fas fa-check"></i>
                                                                                        :
                                                                                        <i className="fas fa-times"></i>
                                                                                }
                                                                            </div>
                                                                            <div className="feature">
                                                                                {
                                                                                    plan.sla === 1 ?
                                                                                        <i className="fas fa-check"></i>
                                                                                        :
                                                                                        <i className="fas fa-times"></i>
                                                                                }
                                                                            </div>

                                                                        </div>

                                                                        {this.state.selectedPlan === plan.plan_id ?
                                                                            <button id={plan.plan_id + '_button'}
                                                                                    className='plan-button grey-button'>
                                                                                Current Plan
                                                                            </button>
                                                                            :
                                                                            // this.state.selectedPlan === '' ?

                                                                            <button id={plan.plan_id + '_button'}
                                                                                    className='plan-button'

                                                                                    disabled={

                                                                                        plan.plan_id.includes('free') ?

                                                                                            this.state.spinnerActive === true ? true : '' : ''
                                                                                    }

                                                                                    onClick={

                                                                                        plan.plan_id.includes('free') ?
                                                                                            () => this.handleFreePlan('emitto_free_plan') :

                                                                                            // this.state.selectedPlan === 'essentials_yearly' && plan.plan_id === ('boost_yearly') ?
                                                                                            //     this.openUpgradeModal :
                                                                                            () => this.handlePremiumPlan(this.state.planPeriod ? plan.amount / 100 : plan.amount / 100, plan.plan_id, this.state.user.trial_available === 1)}
                                                                            >
                                                                                {
                                                                                    plan.plan_id.includes('free') ?

                                                                                        this.state.spinnerActive === true ?

                                                                                            <span>Start for Free <i
                                                                                                className='fa fa-spin fa-spinner'></i></span>

                                                                                            :
                                                                                            'Start for Free'
                                                                                        :
                                                                                        this.state.selectedPlan.includes('free') || this.state.selectedPlan === '' ?
                                                                                            this.state.user.trial_available === 1 ?
                                                                                                'Start ' + '7 days trial' :
                                                                                                'Get Started'
                                                                                            :
                                                                                            'Upgrade'
                                                                                }
                                                                            </button>
                                                                        }
                                                                    </div>
                                                                    {plan.plan_id.includes('free') ?
                                                                        <p className='cancel-anytime no-card'>No credit card
                                                                            required.</p>
                                                                        :
                                                                        this.state.user.trial_available === 1 ?
                                                                            <p className='cancel-anytime'>Cancel anytime
                                                                                during
                                                                                the Free
                                                                                Trial.
                                                                                You will not be charged. </p>
                                                                            : ''

                                                                    }
                                                                </div>
                                                            :
                                                            plan.plan_id.includes('free') || plan.plan_id.includes('essentials') ?
                                                                ''
                                                                :
                                                                <div id={plan.plan_id}
                                                                     key={plan.plan_id}
                                                                     className={this.state.selectedPlan === plan.plan_id ?
                                                                         'plan grey-plan' : 'plan'
                                                                     }
                                                                >
                                                                    <h2 className="title">
                                                                        {plan.name}
                                                                    </h2>
                                                                    <div className="price-container">
                                                                        <div className="plan-price">
                                                                            {plan.interval === 'year' ?
                                                                                <React.Fragment>
                                                                                    {plan.plan_id.includes('boost') ?
                                                                                        <div className='old-month-price'>
                                                                                            <span>$300</span>
                                                                                        </div>
                                                                                        :
                                                                                        plan.plan_id.includes('essentials') ?
                                                                                            <div
                                                                                                className='old-month-price'>
                                                                                                <span>$100</span>
                                                                                            </div>
                                                                                            :
                                                                                            ''
                                                                                    }
                                                                                    <div className="save-label">
                                                                                        Save 20%
                                                                                    </div>
                                                                                    <div className='old-price'>
                                                                                    </div>
                                                                                    <div className="yearly-label">
                                                                                        billed annually
                                                                                    </div>
                                                                                </React.Fragment>
                                                                                :
                                                                                ''
                                                                            }
                                                                            <span className='currency'>$</span><span
                                                                            className='price'>
                                                                            {/*{*/}
                                                                            {/*this.state.planPeriod ?*/}
                                                                            {/*plan.price.substring(0, plan.price.length - 1) / 12*/}
                                                                            {/*:*/}
                                                                            {/*plan.price.substring(0, plan.price.length - 1)*/}

                                                                            {/*}*/}
                                                                            {
                                                                                this.state.planPeriod ?
                                                                                    plan.price.substring(0, plan.price.length - 1) * 0.8 / 12
                                                                                    :
                                                                                    plan.price.substring(0, plan.price.length - 1)
                                                                            }
                                                                        </span>
                                                                            <span className='plan-period'>/month</span>
                                                                        </div>
                                                                        <div className="feature-rows">
                                                                            <div className="feature"><i
                                                                                className="fas fa-check"></i>
                                                                            </div>
                                                                            <div className="feature">
                                                                                <span className='text-bold'>
                                                                                    $ {plan.platform_limits.sms.price}
                                                                                </span>
                                                                                <span className='price-list'>per SMS
                                                                                    (US)</span>
                                                                            </div>
                                                                            <div className="feature">
                                                                                <span className='text-bold'>
                                                                                    $ {plan.platform_limits.vib.price}

                                                                                </span>
                                                                                <span className='price-list'>per Message
                                                                                    (US)</span>
                                                                            </div>
                                                                            <div className="feature">
                                                                                <span className='text-bold'>

                                                                                    {
                                                                                        plan.plan_id.includes('free') ?
                                                                                            plan.platform_limits.wp.credits :
                                                                                            '$ ' + (plan.platform_limits.wp.price / 1000).toFixed(4)
                                                                                    }

                                                                                </span>
                                                                                <span
                                                                                    className='price-list'>
                                                                                    {
                                                                                        plan.plan_id.includes('free') ?
                                                                                            'Free Notifications Monthly' :
                                                                                            'Per Message'
                                                                                    }
                                                                                </span>
                                                                            </div>
                                                                            <div className="feature">
                                                                                <span className='text-bold'>
                                                                                    {
                                                                                        // plan.plan_id.includes('free') ?
                                                                                        // plan.platform_limits.fb.credits :
                                                                                        '$ ' + (plan.platform_limits.fb.price / 1000).toFixed(4)}
                                                                                </span>
                                                                                <span
                                                                                    className='price-list'> {
                                                                                    // plan.plan_id.includes('free') ?
                                                                                    //     'Free Messages Monthly' :
                                                                                    'Per Message'
                                                                                }</span>
                                                                            </div>
                                                                            <div className="feature">Unlimited</div>
                                                                            <div
                                                                                className="feature">{plan.team_members}</div>
                                                                            <div
                                                                                className="feature">{plan.additional_features.detailed_analytics === 1 ?
                                                                                <i className="fas fa-check"></i> :
                                                                                <i className="fas fa-times"></i>}</div>
                                                                            <div
                                                                                className="feature">{plan.additional_features.ads_manager === 1 ?
                                                                                <i className="fas fa-check"></i> :
                                                                                <i className="fas fa-times"></i>}</div>
                                                                            <div
                                                                                className="feature">{plan.additional_features.wpress_plugin === 1 ?
                                                                                <i className="fas fa-check"></i> :
                                                                                <i className="fas fa-times"></i>}</div>
                                                                            <div
                                                                                className="feature">{plan.campaign_history}</div>

                                                                            <div
                                                                                className="feature">{plan.log_retention}</div>
                                                                            <div
                                                                                className="feature">{plan.url_shortener.name}
                                                                                <div className="tooltip"> ! <span
                                                                                    className="tooltiptext">{plan.url_shortener.description}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                className="feature">{plan.data_privacy}</div>

                                                                            <div className="feature">{plan.support}</div>
                                                                            <div
                                                                                className="feature">{plan.dedicated_onboarding === null ?
                                                                                <i className='fas fa-times'></i> : plan.dedicated_onboarding}</div>
                                                                            <div
                                                                                className="feature">{plan.content_curation === null ?
                                                                                <i className="fas fa-times"></i> : plan.content_curation}</div>
                                                                            <div
                                                                                className="feature">{plan.additional_features.branding === 1 ?
                                                                                <i className="fas fa-times"></i> :
                                                                                <i className="fas fa-check"></i>
                                                                            }
                                                                            </div>
                                                                            <div className="feature">
                                                                                {
                                                                                    plan.content_automation === 1 ?
                                                                                        <i className="fas fa-check"></i>
                                                                                        :
                                                                                        <i className="fas fa-times"></i>

                                                                                }
                                                                            </div>
                                                                            <div className="feature">
                                                                                {
                                                                                    plan.personalization === 1 ?
                                                                                        <i className="fas fa-check"></i>
                                                                                        :
                                                                                        <i className="fas fa-times"></i>
                                                                                }
                                                                            </div>
                                                                            <div className="feature">
                                                                                {
                                                                                    plan.tags_segmentation === 1 ?
                                                                                        <i className="fas fa-check"></i>
                                                                                        :
                                                                                        <i className="fas fa-times"></i>
                                                                                }
                                                                            </div>
                                                                            <div className="feature">
                                                                                {
                                                                                    plan.sla === 1 ?
                                                                                        <i className="fas fa-check"></i>
                                                                                        :
                                                                                        <i className="fas fa-times"></i>
                                                                                }
                                                                            </div>

                                                                        </div>

                                                                        {this.state.selectedPlan === plan.plan_id ?
                                                                            <button id={plan.plan_id + '_button'}
                                                                                    className='plan-button grey-button'>
                                                                                Current Plan
                                                                            </button>
                                                                            :
                                                                            // this.state.selectedPlan === '' ?

                                                                            <button id={plan.plan_id + '_button'}
                                                                                    className='plan-button'
                                                                                    disabled={

                                                                                        plan.plan_id.includes('free') ?

                                                                                            this.state.spinnerActive === true ? true : '' : ''
                                                                                    }
                                                                                    onClick={

                                                                                        plan.plan_id.includes('free') ?
                                                                                            () => this.handleFreePlan('emitto_free_plan') :

                                                                                            // this.state.selectedPlan === 'essentials_yearly' && plan.plan_id === ('boost_yearly') ?
                                                                                            //     this.openUpgradeModal :
                                                                                            () => this.handlePremiumPlan(this.state.planPeriod ? plan.amount / 100 : plan.amount / 100, plan.plan_id, this.state.user.trial_available === 1)}
                                                                            >
                                                                                {
                                                                                    plan.plan_id.includes('free') ?
                                                                                        this.state.spinnerActive ?
                                                                                            <span>Start for Free <i
                                                                                                className='fa fa-spin fa-spinner'></i></span>
                                                                                            :
                                                                                            'Start for Free'

                                                                                        :

                                                                                        this.state.selectedPlan.includes('free') || this.state.selectedPlan === '' ?
                                                                                            this.state.user.trial_available === 1 ?
                                                                                                'Start ' + '7 days trial' :
                                                                                                'Get Started'
                                                                                            :
                                                                                            'Upgrade'
                                                                                }
                                                                            </button>
                                                                        }
                                                                    </div>
                                                                    {plan.plan_id.includes('free') ?
                                                                        <p className='cancel-anytime no-card'>No credit card
                                                                            required.</p>
                                                                        :
                                                                        this.state.user.trial_available === 1 ?
                                                                            <p className='cancel-anytime'>Cancel anytime
                                                                                during
                                                                                the Free
                                                                                Trial.
                                                                                You will not be charged. </p>
                                                                            : ''
                                                                    }
                                                                </div>
                                                        :
                                                        this.state.selectedPlan && this.state.selectedPlan.includes('essentials') ?
                                                            plan.plan_id.includes('free') ? ''
                                                                :
                                                                <div id={plan.plan_id}
                                                                     key={plan.plan_id}
                                                                     className={this.state.selectedPlan === plan.plan_id ?
                                                                         'plan grey-plan' : 'plan'
                                                                     }
                                                                >
                                                                    <h2 className="title">
                                                                        {plan.name}
                                                                    </h2>
                                                                    <div className="price-container">
                                                                        <div className="plan-price">
                                                                            {plan.interval === 'year' ?
                                                                                <React.Fragment>
                                                                                    {plan.plan_id.includes('boost') ?
                                                                                        <div className='old-month-price'>
                                                                                            <span>$300</span>
                                                                                        </div>
                                                                                        :
                                                                                        plan.plan_id.includes('essentials') ?
                                                                                            <div
                                                                                                className='old-month-price'>
                                                                                                <span>$100</span>
                                                                                            </div>
                                                                                            :
                                                                                            ''
                                                                                    }
                                                                                    <div className="save-label">
                                                                                        Save 20%
                                                                                    </div>
                                                                                    <div className='old-price'>
                                                                                    </div>
                                                                                    <div className="yearly-label">
                                                                                        billed annually
                                                                                    </div>
                                                                                </React.Fragment>
                                                                                :
                                                                                ''
                                                                            }
                                                                            <span className='currency'>$</span><span
                                                                            className='price'>
                                                                            {/*{*/}
                                                                            {/*this.state.planPeriod ?*/}
                                                                            {/*plan.price.substring(0, plan.price.length - 1) / 12*/}
                                                                            {/*:*/}
                                                                            {/*plan.price.substring(0, plan.price.length - 1)*/}

                                                                            {/*}*/}
                                                                            {
                                                                                this.state.planPeriod ?
                                                                                    plan.price.substring(0, plan.price.length - 1) * 0.8 / 12
                                                                                    :
                                                                                    plan.price.substring(0, plan.price.length - 1)
                                                                            }
                                                                        </span>
                                                                            <span className='plan-period'>/month</span>
                                                                        </div>
                                                                        <div className="feature-rows">
                                                                            <div className="feature"><i
                                                                                className="fas fa-check"></i>
                                                                            </div>
                                                                            <div className="feature">
                                                                                <span className='text-bold'>
                                                                                    $ {plan.platform_limits.sms.price}
                                                                                </span>
                                                                                <span className='price-list'>per SMS
                                                                                    (US)</span>
                                                                            </div>
                                                                            <div className="feature">
                                                                                <span className='text-bold'>
                                                                                    $ {plan.platform_limits.vib.price}

                                                                                </span>
                                                                                <span className='price-list'>per Message
                                                                                    (US)</span>
                                                                            </div>
                                                                            <div className="feature">
                                                                                <span className='text-bold'>

                                                                                    {
                                                                                        plan.plan_id.includes('free') ?
                                                                                            plan.platform_limits.wp.credits :
                                                                                            '$ ' + (plan.platform_limits.wp.price / 1000).toFixed(4)
                                                                                    }

                                                                                </span>
                                                                                <span
                                                                                    className='price-list'>
                                                                                    {
                                                                                        plan.plan_id.includes('free') ?
                                                                                            'Free Notifications Monthly' :
                                                                                            'Per Message'
                                                                                    }
                                                                                </span>
                                                                            </div>
                                                                            <div className="feature">
                                                                                <span className='text-bold'>
                                                                                    {
                                                                                        // plan.plan_id.includes('free') ?
                                                                                        // plan.platform_limits.fb.credits :
                                                                                        '$ ' + (plan.platform_limits.fb.price / 1000).toFixed(4)}
                                                                                </span>
                                                                                <span
                                                                                    className='price-list'> {
                                                                                    // plan.plan_id.includes('free') ?
                                                                                    //     'Free Messages Monthly' :
                                                                                    'Per Message'
                                                                                }</span>
                                                                            </div>
                                                                            <div className="feature">Unlimited</div>
                                                                            <div
                                                                                className="feature">{plan.team_members}</div>
                                                                            <div
                                                                                className="feature">{plan.additional_features.detailed_analytics === 1 ?
                                                                                <i className="fas fa-check"></i> :
                                                                                <i className="fas fa-times"></i>}</div>
                                                                            <div
                                                                                className="feature">{plan.additional_features.ads_manager === 1 ?
                                                                                <i className="fas fa-check"></i> :
                                                                                <i className="fas fa-times"></i>}</div>
                                                                            <div
                                                                                className="feature">{plan.additional_features.wpress_plugin === 1 ?
                                                                                <i className="fas fa-check"></i> :
                                                                                <i className="fas fa-times"></i>}</div>
                                                                            <div
                                                                                className="feature">{plan.campaign_history}</div>

                                                                            <div
                                                                                className="feature">{plan.log_retention}</div>
                                                                            <div
                                                                                className="feature">{plan.url_shortener.name}
                                                                                <div className="tooltip"> ! <span
                                                                                    className="tooltiptext">{plan.url_shortener.description}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                className="feature">{plan.data_privacy}</div>

                                                                            <div className="feature">{plan.support}</div>
                                                                            <div
                                                                                className="feature">{plan.dedicated_onboarding === null ?
                                                                                <i className='fas fa-times'></i> : plan.dedicated_onboarding}</div>
                                                                            <div
                                                                                className="feature">{plan.content_curation === null ?
                                                                                <i className="fas fa-times"></i> : plan.content_curation}</div>
                                                                            <div
                                                                                className="feature">{plan.additional_features.branding === 1 ?
                                                                                <i className="fas fa-times"></i> :
                                                                                <i className="fas fa-check"></i>
                                                                            }
                                                                            </div>
                                                                            <div className="feature">
                                                                                {
                                                                                    plan.content_automation === 1 ?
                                                                                        <i className="fas fa-check"></i>
                                                                                        :
                                                                                        <i className="fas fa-times"></i>

                                                                                }
                                                                            </div>
                                                                            <div className="feature">
                                                                                {
                                                                                    plan.personalization === 1 ?
                                                                                        <i className="fas fa-check"></i>
                                                                                        :
                                                                                        <i className="fas fa-times"></i>
                                                                                }
                                                                            </div>
                                                                            <div className="feature">
                                                                                {
                                                                                    plan.tags_segmentation === 1 ?
                                                                                        <i className="fas fa-check"></i>
                                                                                        :
                                                                                        <i className="fas fa-times"></i>
                                                                                }
                                                                            </div>
                                                                            <div className="feature">
                                                                                {
                                                                                    plan.sla === 1 ?
                                                                                        <i className="fas fa-check"></i>
                                                                                        :
                                                                                        <i className="fas fa-times"></i>
                                                                                }
                                                                            </div>

                                                                        </div>

                                                                        {this.state.selectedPlan === plan.plan_id ?
                                                                            <button id={plan.plan_id + '_button'}
                                                                                    className='plan-button grey-button'>
                                                                                Current Plan
                                                                            </button>
                                                                            :
                                                                            // this.state.selectedPlan === '' ?

                                                                            <button id={plan.plan_id + '_button'}
                                                                                    className='plan-button'
                                                                                    disabled={

                                                                                        plan.plan_id.includes('free') ?

                                                                                            this.state.spinnerActive === true ? true : '' : ''
                                                                                    }
                                                                                    onClick={

                                                                                        plan.plan_id.includes('free') ?
                                                                                            () => this.handleFreePlan('emitto_free_plan') :

                                                                                            // this.state.selectedPlan === 'essentials_yearly' && plan.plan_id === ('boost_yearly') ?
                                                                                            //     this.openUpgradeModal :
                                                                                            () => this.handlePremiumPlan(this.state.planPeriod ? plan.amount / 100 : plan.amount / 100, plan.plan_id, this.state.user.trial_available === 1)}
                                                                            >
                                                                                {
                                                                                    plan.plan_id.includes('free') ?
                                                                                        this.state.spinnerActive ?
                                                                                            <span>Start for Free <i
                                                                                                className='fa fa-spin fa-spinner'></i></span>
                                                                                            :
                                                                                            'Start for Free' :

                                                                                        this.state.selectedPlan.includes('free') || this.state.selectedPlan === '' ?
                                                                                            this.state.user.trial_available === 1 ?
                                                                                                'Start ' + '7 days trial' :
                                                                                                'Get Started'
                                                                                            :
                                                                                            'Upgrade'
                                                                                }
                                                                            </button>
                                                                        }
                                                                    </div>
                                                                    {plan.plan_id.includes('free') ?
                                                                        <p className='cancel-anytime no-card'>No credit card
                                                                            required.</p>
                                                                        :
                                                                        this.state.user.trial_available === 1 ?
                                                                            <p className='cancel-anytime'>Cancel anytime
                                                                                during
                                                                                the Free
                                                                                Trial.
                                                                                You will not be charged. </p>
                                                                            : ''
                                                                    }
                                                                </div>
                                                            :
                                                            <div id={plan.plan_id}
                                                                 key={plan.plan_id}
                                                                 className={this.state.selectedPlan === plan.plan_id ?
                                                                     'plan grey-plan' : 'plan'
                                                                 }
                                                            >
                                                                <h2 className="title">
                                                                    {plan.name}
                                                                </h2>
                                                                <div className="price-container">
                                                                    <div className="plan-price">
                                                                        {plan.interval === 'year' ?
                                                                            <React.Fragment>
                                                                                {plan.plan_id.includes('boost') ?
                                                                                    <div className='old-month-price'>
                                                                                        <span>$300</span>
                                                                                    </div>
                                                                                    :
                                                                                    plan.plan_id.includes('essentials') ?
                                                                                        <div className='old-month-price'>
                                                                                            <span>$100</span>
                                                                                        </div>
                                                                                        :
                                                                                        ''
                                                                                }
                                                                                <div className="save-label">
                                                                                    Save 20%
                                                                                </div>
                                                                                <div className='old-price'>
                                                                                </div>
                                                                                <div className='old-price'>
                                                                                </div>
                                                                                <div className="yearly-label">
                                                                                    billed annually
                                                                                </div>
                                                                            </React.Fragment>
                                                                            :
                                                                            ''
                                                                        }
                                                                        <span className='currency'>$</span><span
                                                                        className='price'>
                                                                        {/*{*/}
                                                                        {/*this.state.planPeriod ?*/}
                                                                        {/*plan.price.substring(0, plan.price.length - 1) / 12*/}
                                                                        {/*:*/}
                                                                        {/*plan.price.substring(0, plan.price.length - 1)*/}

                                                                        {/*}*/}
                                                                        {
                                                                            this.state.planPeriod ?
                                                                                plan.price.substring(0, plan.price.length - 1) * 0.8 / 12
                                                                                :
                                                                                plan.price.substring(0, plan.price.length - 1)
                                                                        }
                                                                    </span>
                                                                        <span className='plan-period'>/month</span>
                                                                    </div>
                                                                    <div className="feature-rows">
                                                                        <div className="feature"><i
                                                                            className="fas fa-check"></i>
                                                                        </div>
                                                                        <div className="feature">
                                                                            <span className='text-bold'>
                                                                                $ {plan.platform_limits.sms.price}
                                                                            </span>
                                                                            <span className='price-list'>per SMS
                                                                                (US)</span>
                                                                        </div>
                                                                        <div className="feature">
                                                                            <span className='text-bold'>
                                                                                $ {plan.platform_limits.vib.price}

                                                                            </span>
                                                                            <span className='price-list'>per Message
                                                                                (US)</span>
                                                                        </div>
                                                                        <div className="feature">
                                                                            <span className='text-bold'>

                                                                                {
                                                                                    plan.plan_id.includes('free') ?
                                                                                        plan.platform_limits.wp.credits :
                                                                                        '$ ' + (plan.platform_limits.wp.price / 1000).toFixed(4)
                                                                                }

                                                                            </span>
                                                                            <span
                                                                                className='price-list'>
                                                                                {
                                                                                    plan.plan_id.includes('free') ?
                                                                                        'Free Notifications Monthly' :
                                                                                        'Per Message'
                                                                                }
                                                                            </span>
                                                                        </div>
                                                                        <div className="feature">
                                                                            <span className='text-bold'>
                                                                                {
                                                                                    // plan.plan_id.includes('free') ?
                                                                                    // plan.platform_limits.fb.credits :
                                                                                    '$ ' + (plan.platform_limits.fb.price / 1000).toFixed(4)}
                                                                            </span>
                                                                            <span
                                                                                className='price-list'> {
                                                                                // plan.plan_id.includes('free') ?
                                                                                //     'Free Messages Monthly' :
                                                                                'Per Message'
                                                                            }</span>
                                                                        </div>
                                                                        <div className="feature">Unlimited</div>
                                                                        <div
                                                                            className="feature">{plan.team_members}</div>
                                                                        <div
                                                                            className="feature">{plan.additional_features.detailed_analytics === 1 ?
                                                                            <i className="fas fa-check"></i> :
                                                                            <i className="fas fa-times"></i>}</div>
                                                                        <div
                                                                            className="feature">{plan.additional_features.ads_manager === 1 ?
                                                                            <i className="fas fa-check"></i> :
                                                                            <i className="fas fa-times"></i>}</div>
                                                                        <div
                                                                            className="feature">{plan.additional_features.wpress_plugin === 1 ?
                                                                            <i className="fas fa-check"></i> :
                                                                            <i className="fas fa-times"></i>}</div>
                                                                        <div
                                                                            className="feature">{plan.campaign_history}</div>

                                                                        <div
                                                                            className="feature">{plan.log_retention}</div>
                                                                        <div className="feature">{plan.url_shortener.name}
                                                                            <div className="tooltip"> ! <span
                                                                                className="tooltiptext">{plan.url_shortener.description}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            className="feature">{plan.data_privacy}</div>

                                                                        <div className="feature">{plan.support}</div>
                                                                        <div
                                                                            className="feature">{plan.dedicated_onboarding === null ?
                                                                            <i className='fas fa-times'></i> : plan.dedicated_onboarding}</div>
                                                                        <div
                                                                            className="feature">{plan.content_curation === null ?
                                                                            <i className="fas fa-times"></i> : plan.content_curation}</div>
                                                                        <div
                                                                            className="feature">{plan.additional_features.branding === 1 ?
                                                                            <i className="fas fa-times"></i> :
                                                                            <i className="fas fa-check"></i>
                                                                        }
                                                                        </div>
                                                                        <div className="feature">
                                                                            {
                                                                                plan.content_automation === 1 ?
                                                                                    <i className="fas fa-check"></i>
                                                                                    :
                                                                                    <i className="fas fa-times"></i>

                                                                            }
                                                                        </div>
                                                                        <div className="feature">
                                                                            {
                                                                                plan.personalization === 1 ?
                                                                                    <i className="fas fa-check"></i>
                                                                                    :
                                                                                    <i className="fas fa-times"></i>
                                                                            }
                                                                        </div>
                                                                        <div className="feature">
                                                                            {
                                                                                plan.tags_segmentation === 1 ?
                                                                                    <i className="fas fa-check"></i>
                                                                                    :
                                                                                    <i className="fas fa-times"></i>
                                                                            }
                                                                        </div>
                                                                        <div className="feature">
                                                                            {
                                                                                plan.sla === 1 ?
                                                                                    <i className="fas fa-check"></i>
                                                                                    :
                                                                                    <i className="fas fa-times"></i>
                                                                            }
                                                                        </div>

                                                                    </div>

                                                                    {this.state.selectedPlan === plan.plan_id ?
                                                                        <button id={plan.plan_id + '_button'}
                                                                                className='plan-button grey-button'>
                                                                            Current Plan
                                                                        </button>
                                                                        :


                                                                        <button id={plan.plan_id + '_button'}
                                                                                className='plan-button'
                                                                                disabled={

                                                                                    plan.plan_id.includes('free') ?

                                                                                        this.state.spinnerActive === true ? true : '' : ''
                                                                                }
                                                                                onClick={

                                                                                    plan.plan_id.includes('free') ?
                                                                                        () => this.handleFreePlan('emitto_free_plan') :

                                                                                        // this.state.selectedPlan === 'essentials_yearly' && plan.plan_id === ('boost_yearly') ?
                                                                                        //     this.openUpgradeModal :
                                                                                        () => this.handlePremiumPlan(this.state.planPeriod ? plan.amount / 100 : plan.amount / 100, plan.plan_id, this.state.user.trial_available === 1)}
                                                                        >
                                                                            {
                                                                                plan.plan_id.includes('free') ?
                                                                                    this.state.spinnerActive ?
                                                                                        <span>Start for Free <i
                                                                                            className='fa fa-spin fa-spinner'></i></span>
                                                                                        :
                                                                                        'Start for Free' :

                                                                                    this.state.selectedPlan.includes('free') || this.state.selectedPlan === '' ?
                                                                                        this.state.user.trial_available === 1 ?
                                                                                            'Start ' + '7 days trial' :
                                                                                            'Get Started'
                                                                                        :
                                                                                        'Upgrade'
                                                                            }
                                                                        </button>
                                                                    }
                                                                </div>
                                                                {plan.plan_id.includes('free') ?
                                                                    <p className='cancel-anytime no-card'>No credit card
                                                                        required.</p>
                                                                    :
                                                                    this.state.user.trial_available === 1 ?
                                                                        <p className='cancel-anytime'>Cancel anytime
                                                                            during
                                                                            the Free
                                                                            Trial.
                                                                            You will not be charged. </p>
                                                                        : ''
                                                                }
                                                            </div>
                                                    }
                                                </React.Fragment>
                                            }
                                        ) : ''

                                    }
                                </div>
                            </div>

                            <div id="mobile-screen">
                                <div className="plan-chooser">

                                    {stripePlans[0] !== undefined ?
                                        stripePlans.map(plan => {
                                            return <React.Fragment key={plan.plan_id}>
                                                {this.state.selectedPlan && this.state.selectedPlan.includes('boost') ?

                                                    this.state.planPeriod ?
                                                        plan.plan_id.includes('free') || plan.plan_id.includes('essentials') ?
                                                            ''
                                                            :
                                                            <React.Fragment //key={plan.plan_id}
                                                            >

                                                                <div
                                                                    //key={plan.plan_id}
                                                                    id={plan.plan_id}
                                                                    onClick={() => this.choosePlan(plan.plan_id)}

                                                                    className={"plan-tab round-edges-tab active"}
                                                                >

                                                                    {plan.name}
                                                                </div>

                                                            </React.Fragment>
                                                        :
                                                        plan.plan_id.includes('free') || plan.plan_id.includes('essentials') ?
                                                            ''
                                                            :
                                                            <div
                                                                key={plan.plan_id}
                                                                id={plan.plan_id}
                                                                onClick={() => this.choosePlan(plan.plan_id)}
                                                                className={plan.plan_id === this.state.chosenPlan ? "plan-tab active" : 'plan-tab'}
                                                            >
                                                                {plan.name}
                                                            </div>
                                                    :
                                                    this.state.selectedPlan && this.state.selectedPlan.includes('essentials') ?
                                                        plan.plan_id.includes('free') ? ''
                                                            :
                                                            <div
                                                                key={plan.plan_id}
                                                                id={plan.plan_id}
                                                                onClick={() => this.choosePlan(plan.plan_id)}
                                                                className={plan.plan_id === this.state.chosenPlan ? "plan-tab active" : 'plan-tab'}
                                                            >
                                                                {plan.name}
                                                            </div> :
                                                        <div
                                                            id={plan.plan_id}
                                                            key={plan.plan_id}
                                                            onClick={() => this.choosePlan(plan.plan_id)}
                                                            className={plan.plan_id === this.state.chosenPlan ? "plan-tab active" : 'plan-tab'}
                                                        >
                                                            {plan.name}
                                                        </div>
                                                }
                                            </React.Fragment>
                                        })
                                        : ''
                                    }
                                </div>

                                {this.state.chosenPlanFull ?
                                    <div className="plans-container">

                                        <div id={this.state.chosenPlan}
                                             className={this.state.selectedPlan === this.state.chosenPlan ? 'plan grey-plan' : 'plan'}
                                        >
                                            <h2 className="title">
                                                {this.state.chosenPlanFull.name}
                                            </h2>
                                            <div className="price-container">
                                                <div className="plan-price">
                                                    {this.state.chosenPlanFull.interval === 'year' ?
                                                        <React.Fragment>
                                                            {this.state.chosenPlanFull.plan_id.includes('boost') ?
                                                                <div className='old-month-price'>
                                                                    <span>$300</span>
                                                                </div>
                                                                :
                                                                this.state.chosenPlanFull.plan_id.includes('essentials') ?
                                                                    <div
                                                                        className='old-month-price'>
                                                                        <span>$100</span>
                                                                    </div>
                                                                    :
                                                                    ''
                                                            }
                                                            <div className="save-label">
                                                                Save 20%
                                                            </div>
                                                            <div className='old-price'>
                                                            </div>
                                                            <div className="yearly-label">
                                                                billed annually
                                                            </div>
                                                        </React.Fragment>
                                                        :
                                                        ''
                                                    }
                                                    <span className='currency'>$</span><span
                                                    className='price'>{
                                                    this.state.planPeriod ?
                                                        this.state.chosenPlanFull.price.substring(0, this.state.chosenPlanFull.price.length - 1) * 0.8 / 12
                                                        :
                                                        this.state.chosenPlanFull.price.substring(0, this.state.chosenPlanFull.price.length - 1)
                                                }</span>
                                                    <span className='plan-period'>/month</span>
                                                </div>
                                            </div>
                                            <div className="feature-rows">
                                                <div className="feature ">
                                                    <div className="feature-name feature-sms">
                                                        <i className="fas fa-comment-dots"></i>SMS
                                                    </div>
                                                    <div className="feature-value">
                                                        <span className='text-bold'>
                                                            <span className='text-bold'>
                                                                $ {this.state.chosenPlanFull.platform_limits.sms.price}
                                                            </span>
                                                        </span>
                                                        <span className='price-list'>per SMS (US)</span>
                                                    </div>
                                                </div>
                                                <div className="feature ">
                                                    <div className="feature-name feature-viber">
                                                        <i className='fab fa-viber'></i> Viber
                                                    </div>
                                                    <div className="feature-value">
                                                        <span className='text-bold'>
                                                            $ {this.state.chosenPlanFull.platform_limits.vib.price}

                                                        </span>
                                                        <span className='price-list'>per Message (US)</span>
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-name feature-webpush">
                                                        <i className='fas fa-bell'></i> Web Push
                                                    </div>


                                                    <div className="feature-value">

                                                        <span className='text-bold'>

                                                            {
                                                                this.state.chosenPlanFull.plan_id.includes('free') ?
                                                                    this.state.chosenPlanFull.platform_limits.wp.credits :
                                                                    '$ ' + (this.state.chosenPlanFull.platform_limits.wp.price / 1000).toFixed(4)
                                                            }

                                                        </span>
                                                        <span
                                                            className='price-list'>
                                                            {
                                                                this.state.chosenPlanFull.plan_id.includes('free') ?
                                                                    'Free Notifications Monthly' :
                                                                    'Per Message'
                                                            }
                                                        </span>
                                                    </div>

                                                </div>
                                                <div className="feature  text-center">
                                                    <div className="feature-name feature-messenger">
                                                        <i className='fab fa-facebook-messenger'></i> Facebook Messenger
                                                    </div>
                                                    <div className="feature-value">
                                                        <span className='text-bold'>
                                                            {
                                                                // this.state.chosenPlanFull.plan_id.includes('free') ?
                                                                // this.state.chosenPlanFull.platform_limits.fb.credits :
                                                                '$ ' + (this.state.chosenPlanFull.platform_limits.fb.price / 1000).toFixed(4)}
                                                        </span>
                                                        <span
                                                            className='price-list'> {
                                                            // this.state.chosenPlanFull.plan_id.includes('free') ?
                                                            //     'Free Messages Monthly' :
                                                            'Per Message'
                                                        }</span>
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className="fas fa-user-check"></i>Unlimited Subscribers
                                                    </div>
                                                    <div className="feature-value">
                                                        <i className="fas fa-check"></i>
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className='fas fa-user-friends'></i> Unlimited Team Members
                                                    </div>
                                                    <div className="feature-value">
                                                        <i className="fas fa-check"></i>

                                                    </div>
                                                </div>
                                                <div className="feature feature-button">
                                                    {this.state.selectedPlan === this.state.chosenPlan ?
                                                        <button id={this.state.chosenPlanFull.plan_id + '_button'}
                                                                className='plan-button grey-button'>
                                                            Current Plan
                                                        </button>
                                                        :
                                                        // this.state.selectedPlan === '' ?
                                                        <React.Fragment>
                                                            {/*{console.log('chosenPlanFull: ', this.state.chosenPlanFull)}*/}
                                                            <button id={this.state.chosenPlanFull.plan_id + '_button'}
                                                                    className='plan-button'
                                                                    disabled={

                                                                        this.state.chosenPlanFull.plan_id.includes('free') ?

                                                                            this.state.spinnerActive === true ? true : '' : ''
                                                                    }
                                                                    onClick={
                                                                        this.state.chosenPlan.includes('free') ?
                                                                            () => this.handleFreePlan('emitto_free_plan')
                                                                            :
                                                                            () => this.handlePremiumPlan(this.state.planPeriod ? this.state.chosenPlanFull.amount / 100 : this.state.chosenPlanFull.amount / 100, this.state.chosenPlanFull.plan_id, this.state.user.trial_available !== 0)
                                                                    }
                                                            >
                                                                {
                                                                    this.state.chosenPlan.includes('free') ?
                                                                        this.state.spinnerActive ?
                                                                            <span>Start for Free <i
                                                                                className='fa fa-spin fa-spinner'></i></span>
                                                                            :
                                                                            'Start for Free' :

                                                                        this.state.selectedPlan.includes('free') || this.state.selectedPlan === '' ?
                                                                            this.state.user.trial_available !== 0 ?
                                                                                'Start ' + '7' + ' days trial' :
                                                                                'Get Started'
                                                                            :
                                                                            'Upgrade'
                                                                }
                                                            </button>
                                                        </React.Fragment>
                                                    }                                                </div>
                                                <div className="feature features-banner">
                                                    Features:
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className="fas fa-chart-pie"></i>
                                                        Detailed Analytics
                                                    </div>
                                                    <div className="feature-value  ">
                                                        {this.state.chosenPlanFull.additional_features.detailed_analytics === 1 ?
                                                            <i className="fas fa-check"></i> :
                                                            <i className="fas fa-times"></i>}
                                                    </div>
                                                </div>


                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className="fas fa-ad"></i>Ads Manager
                                                        <div className="tooltip"> ! <span
                                                            className="tooltiptext">Create Facebook Messenger Subscriber
                                                            Acquisition Campaign right from Emitto. </span>
                                                        </div>
                                                    </div>
                                                    <div className="feature-value  ">
                                                        {this.state.chosenPlanFull.additional_features.ads_manager === 1 ?
                                                            <i className="fas fa-check"></i> :
                                                            <i className="fas fa-times"></i>}
                                                    </div>
                                                </div>


                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className='fab fa-wordpress'></i> Wordpress Plugin
                                                        <div className="tooltip"> ! <span
                                                            className="tooltiptext">Get started with Web Push
                                                            Notifications in minutes by simply installing Emitto Plugin
                                                            on your website. </span>
                                                        </div>
                                                    </div>
                                                    <div className="feature-value  ">
                                                        {this.state.chosenPlanFull.additional_features.wpress_plugin === 1 ?
                                                            <i className="fas fa-check"></i> :
                                                            <i className="fas fa-times"></i>}
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className="fas fa-history"></i>Campaign History

                                                    </div>
                                                    <div className="feature-value  ">
                                                        {this.state.chosenPlanFull.campaign_history}
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className="fas fa-history"></i>Log Retention

                                                    </div>
                                                    <div className="feature-value  ">
                                                        {this.state.chosenPlanFull.log_retention}
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className='fas fa-link'></i> URL Shortener with
                                                        Analytics <div
                                                        className="tooltip"> ! <span
                                                        className="tooltiptext"></span>
                                                    </div>
                                                    </div>
                                                    <div className="feature-value  ">
                                                        <i className="fas fa-check"></i>
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className="fas fa-lock"></i>Data Privacy


                                                    </div>
                                                    <div className="feature-value  ">
                                                        {this.state.chosenPlanFull.data_privacy}
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className="fas fa-child"></i>Support


                                                    </div>
                                                    <div className="feature-value  ">
                                                        {this.state.chosenPlanFull.support}
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className="fas fa-map-signs"></i>Dedicated
                                                        Onboarding
                                                        <div className="tooltip"> ! <span
                                                            className="tooltiptext">1-on-1 onboarding session with our
                                                            founder to help you get the most out of Emitto.
                                                        </span>
                                                        </div>

                                                    </div>
                                                    <div className="feature-value  ">
                                                        {this.state.chosenPlanFull.dedicated_onboarding === null ?
                                                            <i className='fas fa-times'></i> : this.state.chosenPlanFull.dedicated_onboarding}                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className="fas fa-compress"></i>Content Curation
                                                        <div className="tooltip"> ! <span
                                                            className="tooltiptext">
                                                            Accumulate newly published content from
                                                            multiple sources and send them to your audience with one
                                                            click.
                                                        </span>
                                                        </div>

                                                    </div>
                                                    <div className="feature-value  ">
                                                        {this.state.chosenPlanFull.dedicated_onboarding === null ?
                                                            <i className='fas fa-times'></i> : this.state.chosenPlanFull.dedicated_onboarding}                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className="fas fa-clipboard-check"></i>Branding Removal
                                                        <div className="tooltip"> ! <span
                                                            className="tooltiptext">Remove Emitto branding from your
                                                            campaigns.</span>
                                                        </div>

                                                    </div>
                                                    <div className="feature-value  ">
                                                        {this.state.chosenPlanFull.additional_features.branding === 1 ?
                                                            <i className="fas fa-times"></i> :
                                                            <i className="fas fa-check"></i>
                                                        }                                               </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className="fas fa-magic"></i>Automations
                                                        <div className="tooltip"> ! <span
                                                            className="tooltiptext">RSS to Web Push - Zero-click
                                                            Automation.</span>
                                                        </div>

                                                    </div>
                                                    <div className="feature-value  ">
                                                        {this.state.content_automation === 1 ?
                                                            <i className="fas fa-check"></i> :
                                                            <i className="fas fa-check"></i>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className="fas fa-fingerprint"></i>Personalized
                                                        Messages
                                                        <div className="tooltip"> ! <span
                                                            className="tooltiptext">Personalize your messages by using
                                                            tags such are 'First Name', 'Last Name' or 'Company'.</span>
                                                        </div>

                                                    </div>
                                                    <div className="feature-value  ">
                                                        {this.state.chosenPlanFull.personaization === 1 ?
                                                            <i className="fas fa-times"></i> :
                                                            <i className="fas fa-check"></i>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className="fas fa-tag"></i>Audience Segmentation
                                                        <div className="tooltip"> ! <span
                                                            className="tooltiptext">
                                                            Segment your audience by their demographics
                                                            or interests in details, such are the country they are from,
                                                            gender
                                                            or consumer habits.
                                                        </span>
                                                        </div>

                                                    </div>
                                                    <div className="feature-value  ">
                                                        {
                                                            this.state.chosenPlanFull.tags_segmentation === 1 ?
                                                                <i className="fas fa-check"></i>
                                                                :
                                                                <i className="fas fa-times"></i>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-name">
                                                        <i className="fas fa-pen-alt"></i>Service Level Agreement
                                                    </div>
                                                    <div className="feature-value  ">
                                                        {
                                                            this.state.chosenPlanFull.sla === 1 ?
                                                                <i className="fas fa-check"></i>
                                                                :
                                                                <i className="fas fa-times"></i>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.selectedPlan === this.state.chosenPlan ?
                                                <button id={this.state.chosenPlanFull.plan_id + '_button'}
                                                        className='plan-button grey-button'>
                                                    Current Plan
                                                </button>
                                                :
                                                // this.state.selectedPlan === '' ?
                                                <React.Fragment>
                                                    {/*{console.log('chosenPlanFull: ', this.state.chosenPlanFull)}*/}
                                                    <button id={this.state.chosenPlanFull.plan_id + '_button'}
                                                            className='plan-button'
                                                            disabled={

                                                                this.state.chosenPlanFull.plan_id.includes('free') ?

                                                                    this.state.spinnerActive === true ? true : '' : ''
                                                            }
                                                            onClick={
                                                                this.state.chosenPlan.includes('free') ?
                                                                    () => this.handleFreePlan('emitto_free_plan') :
                                                                    () => this.handlePremiumPlan(this.state.planPeriod ? this.state.chosenPlanFull.amount / 100 : this.state.chosenPlanFull.amount / 100, this.state.chosenPlanFull.plan_id, this.state.user.trial_available !== 0)
                                                            }
                                                    >
                                                        {
                                                            this.state.chosenPlan.includes('free') ?
                                                                this.state.spinnerActive ?
                                                                    <span>Start for Free <i
                                                                        className='fa fa-spin fa-spinner'></i></span>
                                                                    :
                                                                    'Start for Free' :

                                                                this.state.selectedPlan.includes('free') || this.state.selectedPlan === '' ?
                                                                    this.state.user.trial_available !== 0 ?
                                                                        'Start ' + '7' + ' days trial' :
                                                                        'Get Started'
                                                                    :
                                                                    'Upgrade'
                                                        }
                                                    </button>
                                                </React.Fragment>
                                            }
                                        </div>


                                    </div>
                                    :
                                    ''}
                            </div>


                            <p className='text-center'>Each workspace is billed separately.</p>

                            {
                                this.state.selectedPlan !== '' ?
                                    <a className='close-plans' href='/billing/subscriptions'>I don't need an upgrade
                                        right now</a>
                                    :
                                    ''
                            }
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}